
export const en = {

    'version': '1.167',
    // header
    'menu1': 'Home',
    'menu2': 'Mutual Fund',
    'menu3': 'Private Fund',
    'menu4': 'Provident Fund',
    'menu5': 'Plan Your Investment',
    'menu6': 'Service Channels',
    'menu7': 'About Us',
    'menu8': 'Contact Us',
    'oneLive': 'ONE LIVE : ONLINE TRADING SERVICE',
    'search': 'SEARCH',
    'searchonly': 'SEARCH',
    'text_close': 'Close',

    // footer
    'fmenu1': 'Home',
    'fmenu2': 'Corporate Governance',
    'fmenu3': 'Mutual Fund',
    'fmenu4': 'Investment Management Supervision',
    'fmenu5': 'Plan Your Investment',
    'fmenu6': 'Service Channels',
    'fmenu7': 'Private Fund',
    'fmenu8': 'News/Announcement',
    'fmenu9': 'Provident Fund',
    'fmenu10': 'Promotions/Privileges',
    'fmenu11': 'Fund Holiday Calendar',
    'fmenu12': 'Frequently Asked Questions',
    'fmenu13': 'Sitemaps',
    'fmenu14': 'Jobs Apply',
    'fmenu15': 'Contact Us',
    'fmenu16': 'Privacy Notice',
    'fmenu17': 'Privacy Notice For Employees ',
    'ftitle': 'INVESTORS SHOULD UNDERSTAND PRODUCT FEATURES, CONDITIONS OF RETURN, AND RISK BEFORE MAKING AN INVESTMENT DECISION.',
    'back': 'Back',
    'back2': 'Back',
    'backpro': 'Back To Promotions/Privileges',
    'backcal': 'Back To Plan Your Investment',
    'backfundcom': 'Back To Comparison Fund',
    'backfundrecom': 'Back To Recommended Fund',
    'backfundmarket': 'Back To Market Summary',


    // Home-page #1
    // sub-4menu
    'sub4menu1': 'PLAN YOUR INVESTMENT',
    'sub4menu2': 'MARKET UPDATE',
    'sub4menu3': 'PROMOTIONS/ PRIVILEGES',
    'sub4menu4': 'DOWNLOAD FORMS',

    // 2box
    'twoboxtitle1': 'INVESTMENT CALCULATOR',
    'twoboxtitle2': 'FUND PERFORMANCE',
    'twoboxdetail1': 'CALCULATION TOOL THAT WILL HELP YOU CALCULATE YOUR INVESTMENT EASILY, QUICKLY, AND CONVENIENTLY.',
    'twoboxdetail2': 'PLEASE SELECT A FUND FOR THE FUND PERFORMANCE HERE',

    // defaultTitle-select
    'defaulttitle1': 'SELECT FUND',
    'defaulttitle2': 'DATE OF INVESTMENT',
    'defaulttitledate1': 'INVESTMENT DATE',
    'defaulttitledate2': 'INFORMATION AS OF',
    'defaulttitlebtn': 'RUN',
    // "defaulttitlebtn2": "RUN",

    // defaultTitle-select2
    'menutitlebar0': 'RECOMMENDED FUND',
    'menutitlebar1': 'REAL ESTATE INVESTMENT TRUST',
    'menutitlebar2': 'MONEY MARKET FUND',
    'menutitlebar3': 'EQUITY FUND',
    'menutitlebar4': 'FIXED INCOME FUND',
    'menutitlebar5': 'TERM FUND',
    'menutitlebar6': 'MIXED FUND',
    'menutitlebar7': 'EQUITY FOREIGN INVESTMENT FUND',
    'menutitlebar8': 'FIXED INCOME FOREIGN INVESTMENT FUND',
    'menutitlebar9': 'MIXED FOREIGN INVESTMENT FUND',
    'menutitlebar10': 'EXCHANGE TRADED FUND (ETF)',
    'menutitlebar11': 'LONG TERM EQUITY FUND (LTF)',
    'menutitlebar12': 'RETIREMENT MUTUAL FUND (RMF)',
    'menutitlebar13': 'SECTOR FUND',
    'menutitlebar14': 'ALTERNATIVE INVESTMENT FUND',
    'menutitlebar15': 'COUNTRY FUND',
    'menutitlebar16': 'PROPERTY FUND',
    'menutitlebar17': 'SUPER SAVINGS FUND (SSF)',
    'menutitlebar18': 'Thailand ESG Fund',
    'menutitlebar19': 'Other Fund',

    // box3
    'titlebox3': 'NAV',
    'searchtitle3': 'NAV SEARCH',
    'subtitlebox3': 'SELECT FUND BY INVESTMENT POLICY',

    // box4
    'titlebox4': 'Follow NAV of your favorite Funds by click',
    'labelpsbox4': 'RECOMMENDED FUND',

    // box5
    'titlebox5': 'Don\'t know which fund to choose? ',
    'detailbox5': 'Let us recommend the best fund for you.',
    'menu1box5': 'OUTSTANDING PERFORMANCE FUND',
    'menu2box5': 'RECOMMENDED FUND',
    'menu3box5': 'ASSET ALLOCATION',
    'btnbox5': 'SEE ALL FUND',
    'menu2box5ex': 'RECOMMENDED FUND (Measured by the excellent return)',

    // box6
    'menu1box6': 'NEWS >',
    'menu2box6': 'RECOMMENDED FUND >',
    'menu3box6': 'ANNOUNCEMENT >',
    'menu4box6': 'PROMOTIONS >',
    'menu5box6': 'Earth Update >',

    // fund-card
    'fundcardtitle1': 'NAV',
    'fundcardtitle2': 'Offer',
    'fundcardtitle3': 'Bid',
    'fundcardtitle3_1': 'Price',
    'fundcardtitle4': 'Total Net Assets(THB)',
    'fundcardtitle5': 'INFORMATION AS OF',
    'fundcardtitle6': 'Total Asset Value(THB)',

    // กองทุนรวม #2
    'p2title': 'Don\'t know which fund to select? Let\'s select a Mutual Fund from 3 main investment objectives.',
    'p2titlelbox': 'Select Fund from the desired GOAL',
    'p2titlerbox': 'Select Fund in accordance with the acceptable risk levels',
    'p2titlecbox': 'SELECT FUND BY INVESTMENT POLICY',
    // Lbox
    'p2titlelboxmenu1': 'NEW INVESTOR',
    'p2titlelboxmenu2': 'INVESTMENT TARGET',
    'p2titlelboxmenu3': 'RETIREMENT',
    // Rbox
    'p2titlerboxmenu1': 'LOW RISK',
    'p2titlerboxmenu2': 'MODERATE RISK',
    'p2titlerboxmenu3': 'HIGH RISK',
    // Cbox
    'menudetailbar1': '',
    'menudetailbar2': 'A fund that we invest in stable and highly liquid debt instruments, such as deposits, government debt instruments, and money institution debt instruments. A Money Market Fund is suitable for investors who seek short-term investment and are able to accept a risk or investment providing low returns.',
    'menudetailbar3': 'A fund focuses on investing in registered stocks having a good fundamental, high growth trend and opportunity to provide high returns. It is suaitable for investors who seek high returns and are able to accept the risk of fund volatility.',
    'menudetailbar4': 'A Fixed Income Fund is investment in debt instruments, such as government bonds, promissory notes, bills of exchange, debentures, and deposits. It is suitable for investors who are able to accept a low risk. The investors can choose types of fixed inome fund suitable to themselves.',
    'menudetailbar5': 'TERM FUND',
    'menudetailbar6': 'A Mixed Fund is a fund that diversifies investment in various types of securities, such as debt instruments, equity instruments, and derivatives, in a portion appropriate to the investment situation in each period of time or within a framework of the determined investment policy with various types of investment.',
    'menudetailbar7': 'A fund focuses on investing in registered stocks having a good fundamental, high growth trend and opportunity to provide high returns. It is suaitable for investors who seek high returns and are able to accept the risk of fund volatility.',
    'menudetailbar8': 'Alternative to diversify investment in assets overseas with various investment policies.',
    'menudetailbar9': 'A fund that diversifies investment in various types of securities, such as debt instruments, equity instruments, and derivatives, in a portion appropriate to the investment situation in each period of time or within a framework of the determined investment policy (Asset Allocation) with various types of investment.',
    'menudetailbar10': 'An opened-end fund registered in the Stock Exchange has an investment policy focusing on creating returns that are almost the same as or eqivalent to the underlying index, security index and gold price, for example. Investors are able to trade resembling to stock trading in the Stock Exchange 1. Opened-end Fund, ThaiDEX SET 50 ETF (TDEX) aiming to create almost the same returns as SET50 Index 2. Opened-end Fund, ThaiDEX SET10 ETF (TH100) aiming to create alomist the same returns as SET100 Index 3. Opened-end fund, ThaiDEX SET High Dividend ETF (1DIV) investing in securities that are a component of SET High Dividend 30 Index to create almost the same return as the index 4. Opended-end fund, One STOXX ASEAN Select Dividend Index Fund (ONE-STOXXASEAN) aimimg to crete good returns almost the same as STOXX ASEAN SELECT DIVIDEND 30 INDEX and the fund is under the ASEAN CIS project and will comply with the rule prescribed in the Standards of Qualifying CIS of the Memorandum of Understanding on Streamlined Authorisation Framework for Cross-border Public Offers of ASEAN Collective Investment Schemes',
    'menudetailbar11': 'IT IS SUITABLE FOR AN INVESTOR WHO EXPECTS THE LONG-TERM INVESTMENT AND … INVESTMENT FROM TAX BENEFIT. SAVE TAX … ',
    'menudetailbar12': 'A fund that a taxpayer can choose to invest to save money up for retirement and receive a tax deduction privilege from the Government as incentive. It is suitable for investors who want to make a financial plan for the stability of life after retirement.',
    'menudetailbar13': 'A mutual fund that focuses on investing in a certain group of industries, such as real estate, so the investment is highly concentrated. It is suitable for investors who are able to accept a high risk.',
    'menudetailbar14': 'ALTERNATIVE INVESTMENT FUND',
    'menudetailbar15': 'COUTRY FUND',
    'menudetailbar16': 'A mutual fund that uses money from selling unit trusts to purchase or lease properties and make benefits of the properties by leasing out the invested properties, an office, dwelling, mall, hotel, factory, storage, etc, as specified in the investment policy of each fund. Unit trusts initially are offered to the public and investors and the unit trusts will be registered to the Stock Exchange of Thailand to increase liquidity for investors. It is suitable for investors who are not able to invest a large amount of money in a property for leasing so they are be able to invest a smaller amount of money to collect lease payment and return it to unit holders as dividend.',
    'menudetailbar17': 'A mutual fund that has a purpose of encouraging long-term savings of investors and includes a fund classified by the types of unit trusts in acccordance with a tax privilege. Unit holders will receive a tax privilege when investors purchase unit trusts and comply with the rule, procedure, and condition specified by the Revenue Department and/or other relevent law.',

    // fund-list-component
    'fundlisttitle1': 'FUND',
    'fundlisttitle2': 'RISK',
    'fundtitlerisk': 'Portfolios to win inflation',

    // fund-risk-component
    'fundriskdetailtitle1': 'Expected rate of return per year',
    'fundriskdetailtitle2': 'Chance to win inflation in 1 year',
    'fundriskdetailtitle3': 'The Risk of this investment portfolio',
    'fundriskdetailtitle4': 'MONEY MARKET FUND',
    'fundriskdetailtitle5': 'FIXED INCOME FUND',
    'fundriskdetailtitle6': 'MIXED FUND',
    'fundriskdetailtitle7': 'EQUITY FUND',
    'fundriskdetailtitle8': 'ALTERNATIVE FUND',

    // Graph title
    'graphtitle1': 'MONEY MARKET FUND',
    'graphtitle2': 'FIXED INCOME FUND',
    'graphtitle3': 'MIXED FUND',
    'graphtitle4': 'EQUITY FUND',
    'graphtitle5': 'ALTERNATIVE FUND',

    // Assumption
    'assumptiontitle': 'To calculate the estimated return as of 30/11/2016',
    'assumptiondetail1': 'In the next 1-year, the policy rate is 1.625%.',
    'assumptiondetail2': 'In the next 1-year, SET Index moves in the frame of 1,520 - 1,850 points with a base at 1,640 points.',
    'assumptiondetail3': 'In the next 1-year, the Fed raised its policy rate two times to 1.00 - 1.25%.',
    'assumptiondetail4': 'The global economic outlook has recovered, especially in the USA,  while China has not been significantly impacted by the tariffs policies and the EU is not affected by political risks.',
    'assumptiondetail5': 'Note: 95% Var indicates the probability that the return of the fund will be negative, the highest at 95% confidence.',
    'assumptiondetail6': 'Recommended Portfolio based on the above risk level. It is a general investment portfolio approach only, and it is not a guarantee of a return on the investment portfolio. The return can vary according to market conditions. Investors are advised to receive individual investment advice and should study fund information before investing.',

    // กองทุนส่วนบุคคล app-private-fund
    'privatetitile1': 'PRIVATE FUND',
    'privatdetail1': 'An individual, a group of individuals, or a juristic person who has a purpose of investing in various types of securities that has delegated a management company or a money institution obtained a private fund license to manage investing money. The management company and investors will make understanding between each other of an invesment policy by concluding a written contract between the management company and each investor prior to receiving investing money or assets to manage.',
    'privatdetail2': 'The management companay will request the information of client\'s financial status, financial burden, investment period, investment experience, acceptable risk levels, and expected returns, to know the status of the client and use the information for the analysis to determine an investment policy suitable for the client. The investment will be under the supervision of the Securities and Exchange Commission.',
    'privattitle1sub1': 'KEY HIGHLIGHTS OF PRIVATE FUND',
    'privattitle1sub1menu1line1': 'To invest in accordance',
    'privattitle1sub1menu1line2': 'with the acceptable risk levels',
    'privattitle1sub1menu2line1': 'Have high liquidity ',
    'privattitle1sub1menu2line2': 'and can change an investment policy',
    'privattitle1sub1menu3line1': 'Manage by professionals',
    'privattitle1sub1menu3line2': 'experienced',

    'privattitle1sub2': 'BENEFITS',
    'privattitle1sub2detailline1': 'Investing money is more diversified compared to direct investment',
    'privattitle1sub2detailline2': 'The management company will find opportunities to invest in a new instrument that continuously provides high returns.',
    'privattitle1sub2detailline3': 'Have a higher bargaining power from investment management',
    'privattitle1sub2detailline4': 'Reduce the burden to contact financial  institutions, follow news, and manage investment.',

    'privatetitile2': 'SERVICE OF ONE ASSET MANAGEMENT LIMITED PRIVATE FUND',
    'privatetitile2sub1': 'PER WEEK',
    'privatetitile2sub2': 'PER MONTH',
    'privatetitile2sub3': 'PER YEAR',

    'privatetitile2sub1list1': 'PORTFOLIO STATUS REPORT',

    'privatetitile2sub2list1': 'PORTFOLIO STATUS REPORT AND FUND PERFORMANCE',
    'privatetitile2sub2list2': 'SECURITIES TRADING REPORT - EQUITY INSTRUMENTS',
    'privatetitile2sub2list3': 'SECURITIES TRADING REPORT - DEBT INSTRUMENTS',
    'privatetitile2sub2list4': 'NET ASSET VALUE (NAV)',
    'privatetitile2sub2list5': 'INVESTMENT REPORT THAT MAY HAVE A CONFLICT OF INTEREST',
    'privatetitile2sub2list6': 'OTHER BENEFITS REPORT',
    'privatetitile2sub2list7': 'VOTING REPORT',
    'privatetitile2sub2list8': 'OTHER REPORT UPON CLIENT\'S REQUEST',

    'privatetitile2sub3list1': 'A fund manager announces the performance report and the investment in the the next period.',
    'privatetitile2sub3list2': 'Invitation to academic seminars for the highest benefit of clients',

    'privatetitile3': 'DOWNLOAD DOCUMENTS',

    'privatetitile4': 'TYPES OF INVESTMENT AND RISKS',
    'privatetitile4detail': 'One Asset Management Limited. would like to propose various types of private fund to match a client\'s objectives and investment returns as follows:',

    'privatetitile5': 'Conservative Portfolio',
    'privatetitile5detail': 'Suitable to a person who seeks stable returns and is able to accept a low risk.',
    'privatetitile5sub1': 'INVESTMENT POLICY',
    'privatetitile5sub1detail': 'focusing on investing in the money market and debt instruments. It may invest in the money market or stock exchange in a little portion or none, depending on the risk level that a client is able to accept. ',
    'privatetitile5sub2': 'EXPECTED INVESTMENT RETURNS',
    'privatetitile5sub2detail': 'HIGHER THAN DEPOSIT INTEREST',

    'privatetitile6': 'Moderate Portfolio',
    'privatetitile6detail': 'Suitable to a person who seeks moderate returns and is able to accept a moderate risk. ',
    'privatetitile6sub1': 'INVESTMENT POLICY',
    'privatetitile6sub1detail': 'focusing on investing in the money market and debt instruments. It may invest in the money market or stock exchange in a little portion or none, depending on the risk level that a client is able to accept. ',
    'privatetitile6sub2': 'EXPECTED INVESTMENT RETURNS',
    'privatetitile6sub2detail': 'HIGHER THAN FUND CONSERVATIVE PORTFOLIO',

    'privatetitile7': 'Aggressive Portfolio',
    'privatetitile7detail': 'Suitable to a person who is able to accept a high risk to receive high returns in the future.',
    'privatetitile7sub1': 'INVESTMENT POLICY',
    'privatetitile7sub1detail': 'focusing on investing firstly in the capital market or stock exchange. It may allocate some money to invest in the money market or none. Returns will derive from long-term and moderate-term investment value added including dividends.',
    'privatetitile7sub2': 'EXPECTED INVESTMENT RETURNS',
    'privatetitile7sub2detail': 'HIGHER THAN MODERATE PORTFOLIO',

    'contaxtitle': 'CONTACT US',
    'contaxaddressline1': 'One Asset Management Limited',
    'contaxaddressline2': 'Siam Piwat Tower, 9th and 24th  Floor, 989 Rama 1 Road Pathumwan, Bangkok 10330',
    'contaxdetail': 'PRIVATE FUND AND PROVIDENT FUND',
    'contaxtel1': '0-2659-8749, 0-2659-8758',
    'contaxtel2': '0-2659-8764',
    'contaxemail': 'pd@one-asset.com',

    // provident-fund กองทุนสำรองเลี้ยงชีพ
    'providenttitle1': 'FUND OVERVIEW',
    'providenttitle1detail': 'WHAT IS A PROVIDENT FUND?',
    'providenttitle1detailmenu1line1': 'voluntarily established',
    'providenttitle1detailmenu1line2': 'by employer',
    'providenttitle1detailmenu1line3': 'and employees.',
    'providenttitle1detailmenu2line1': 'Including employee’s  ',
    'providenttitle1detailmenu2line2': 'contribution and employer’s',
    'providenttitle1detailmenu2line3': 'contribution',
    'providenttitle1detailmenu3line1': 'is a',
    'providenttitle1detailmenu3line2': 'long-term saving',
    'providenttitle1detailmenu4line1': 'registered a fund as juristic person ',
    'providenttitle1detailmenu4line2': 'to the Securities',
    'providenttitle1detailmenu4line3': 'and  Exchange Commission',

    'providenttitle1sub1': 'The objectives of the fund',
    'providenttitle1sub1line1': 'Provide employees and their families the guarantee of future security in case of resignation, retirement, or death.',
    'providenttitle1sub1line2': 'Benefits provided by employer to its employees.',
    'providenttitle1sub1line3': 'Promote employee\'s work motivation',
    'providenttitle1sub1line4': 'Promote the saving of private sectors to develop the economy of the country.',

    'providenttitle1sub2': 'BENEFITS OF A PROVIDENT FUND',
    'providenttitle1sub2l': 'TO EMPLOYER',
    'providenttitle1sub2lline1': 'Employer’s contribution paid for employees can be used as company expenditure for tax calculation in the paid year.',
    'providenttitle1sub2lline2': 'Benefits provided to valuable employees to an organization',
    'providenttitle1sub2lline3': 'Build a good image of organization',
    'providenttitle1sub2lline4': 'Reduce turn over of employees',
    'providenttitle1sub2r': 'TO EMPLOYEES',
    'providenttitle1sub2rline1': 'Contribution is deductible for taxation',
    'providenttitle1sub2rline2': 'Promote money saving',
    'providenttitle1sub2rline3': 'Have savings to spend after resignation or retirement',
    'providenttitle1sub2rline4': 'Guarantee for employees and their families to live a secure, dignified, and independent retirement life.',

    'providenttitle2': 'THE STRUCTURE OF PROVIDENT FUND',
    'providenttitle2detail': 'Who are involving persons?...Are you familiar with these persons?',
    'providenttitle2detailline1': 'An employer is a person who has an important role in establishing a provident fund. Without the employer, the provident fund would have not been established. Therefore, the employer is a person who has good intentions to its employees by providing good benefits so its employess will have a lump sum to spend after retirement, resignation, or leaving a provident fund.',
    'providenttitle2detailline2': 'Employees are other significant person in establishing a provident fund. They are required to allow their employer to deduct their salary payment to contribute to the fund and agree to comply with the requirement specified in the regulation of the fund.',
    'providenttitle2detailline3p1': 'The Fund Committee is comprised of: the fund commitee appointed by the employer; the commitee may not be an employee. The fund commitee elected by the employees; the elected person may not be a member of the fund depending on the requirement provided in the regulation; however, in general, the fund committee elected by the employees should be a member of the fund since no one will well understand the  members of the fund as a member itself.',
    'providenttitle2detailline3p2': 'The fund committee has the most important role. It is a representative of the employer and members to manage the fund and to use the money to create the highest benefits to the members within the acceptable risk levels. It is responsible for coordinating to establish the fund, selecting a management company, determining an investment policy in compliance with the structure of the fund, amending the regulation of the fund, for example, which are signficant responsibilities. Certain duties and responsibilities, such as amending the regulation of the fund will have a biding effect on the members to comply with the regulation, and the determination of an investment policy will have an impact on stability and returns of the fund. Thus, before selecting a person to be a representative of the employers or members, they should deliberately select a good person who has knowledge and capability, strong determination, is sacrified and able to devote his/her time to the members. Likewise, the committee shall perform its responsibilities in compliance to the specified law with intergrity and due care as entrusted by the employer and members.',
    'providenttitle2detailline4': 'The Securities and Exchange Commission, abbreviately known as "SEC" , is responsible for supervising person involved with the management of all provident fund, a management company, custodian, and auditor, for example. Other role and responsibility are to act as a registrar of provident fund to register the establishment of provident fund, amendment of the regulation of provident fund, including to oversee the performance of a fund committee.',
    'providenttitle2detailline5': 'A management company is responsible for managing the fund by investing to provide interests to fund\'s members. Therefore, the fund committee has to select an appropriate management company to manage the fund. The management company is required to obtain a private fund license approved by the SEC . The list of management companies approved by the SEC can be accessed at, ',
    'providenttitle2detailline6': 'An auditor is responsible for verifying a financial report and cerifying the correctness of information provided in a fund financial report. Prior to selecting an auditor of a fund, it will require to know the number of members of the fund. If the fund has the number of members not over 100 members, an auditor who holds a certified public accountant is able to verify and provide an opinion on a fund financial statement. But if the fund has the number of members over 100 members, an auditor who is approved by the SEC is able to verify and provide an opinion on a fund financial statement. The list of auditors approved by the SEC can be accessed at ',
    'providenttitle2detailline7': 'A custodian is responsible for safeguarding fund assets, following up benefit on dividend and other benefits deriving from shareholding in invested companies. The custodian is required to be approved by the SEC. The list of custodians approved by the SEC  can be accessed at ',
    'providenttitle2detailline8': 'A member registrar is responsible for preparing the list of members, the amount of employee\'s contribution, employer\'s contribution and benefits provided to each member, and submit an individual report of each member\'s provident fund to members every 6 calendar months. The report must show the amount of each provident fund, the value of provident fund per unit, the value of the employee\'s contribution, the value of the employer\'s contribution, and the benefit of the employee’s contribution and the employer\'s contribution. In most cases, management companies tend to act as a member registrar by themselves, but may also assign other companies licensed by the SEC to be a member registrar instead.',
    'providenttitle2detailline9': 'The Association of Provident Fund is a group of provident fund. Initially, it is comprised of a group of state enterprise provident fund, then it opened up membership to a public sector. It acts as representative to oversee benefits that provident fund should receive, and to coordinate with the officials and other person involved, and gathers and informs of news and information which are useful and enhance knowledge to fund committees and fund members, for example.',
    'providenttitle2detailline10': 'The Association of Investment Management Company (AIMC) is a group of management companies. It is responsible for overseeing the operation of management companies so the operation will be done effectively, including acts as a representative of management companies in contacting and coordinating wiht the officials on various matters. ',
    'providenttitle2detaillinelast': 'Source : The Securities and Exchange Commission',

    'providenttitle3': 'DOWNLOAD DOCUMENTS',

    'providenttitle4': 'Types of investments and risks',
    'providenttitle4detail': 'One Asset Management Limited. would like to propose various types of private fund to match a client\'s objectives and investment returns as follows:',

    'providenttitle5': 'Conservative Portfolio',
    'providenttitle5detail': 'Suitable to a person who seeks stable returns and is able to accept a low risk.',
    'providenttitle5sub1': 'INVESTMENT POLICY',
    'providenttitle5sub1detail': 'focusing on investing in the money market and debt instruments. It may invest in the money market or stock exchange in a little portion or none, depending on the risk level that a client is able to accept. ',
    'providenttitle5sub2': 'EXPECTED INVESTMENT RETURNS',
    'providenttitle5sub2detail': 'HIGHER THAN DEPOSIT INTEREST',

    'providenttitle6': 'Moderate Portfolio',
    'providenttitle6detail': 'Suitable to a person who seeks moderate returns and is able to accept a moderate risk. ',
    'providenttitle6sub1': 'INVESTMENT POLICY',
    'providenttitle6sub1detail': 'focusing on investing in the money market and debt instruments. It may invest in the money market or stock exchange in a little portion or none, depending on the risk level that a client is able to accept. ',
    'providenttitle6sub2': 'EXPECTED INVESTMENT RETURNS',
    'providenttitle6sub2detail': 'HIGHER THAN FUND CONSERVATIVE PORTFOLIO',

    'providenttitle7': 'Aggressive Portfolio',
    'providenttitle7detail': 'Suitable to a person who is able to accept a high risk to receive high returns in the future.',
    'providenttitle7sub1': 'INVESTMENT POLICY',
    'providenttitle7sub1detail': 'focusing on investing firstly in the money market or stock exchange. It may allocate some money to invest in the money market or none. Returns will derive from long-term and moderate-term investment value added including dividends.',
    'providenttitle7sub2': 'EXPECTED INVESTMENT RETURNS',
    'providenttitle7sub2detail': 'HIGHER THAN MODERATE PORTFOLIO',

    // app-calendar ปฏิทิน
    'calendarpagename': 'Fund Calendar',
    'namefund': 'List of funds',

    // app-favorite
    'backfund': 'BACK TO MUTUAL FUND',
    'favoritepagename': 'Favorite Funds',
    'favoritecancle': 'Cancel the following NAV of your favorite Funds by click',
    'favoritenull': 'You don\'t have any interested funds.',

    // News
    'newsmenutab1': 'News',
    'newsmenutab2': 'ANNOUNCEMENT',
    'newsmenutab3': 'Earth Update',
    'newstime': 'PERIOD',
    'newstime1m': 'PREVIOUS 1 MONTH NEWS',
    'newstime3m': 'PREVIOUS 3 MONTHS NEWS',
    'newstime6m': 'PREVIOUS 6 MONTHS NEWS',
    'newstime9m': 'PREVIOUS 9 MONTHS NEWS',
    'newstime12m': 'PREVIOUS 12 MONTHS NEWS',

    // FundrecommComponent
    'fundrecommmenutab1': 'MARKET VIEW/UPDATE',
    'fundrecommmenutab2': 'Newsletter',
    'fundrecommmenutab3': 'VDO Clip',
    'fundrecommmenutab4': 'RECOMMENDED FUND',

    // Promotion
    'promotiontab1': 'PROMOTIONS',
    'promotiontab2': 'PRIVILEGES',

    // Site Map
    'sitemappagename': 'Site Map',
    'sitemaplistext1': 'SERVICE CHANNELS',
    'sitemapmenu2': 'FUND',

    // Jobs Apply
    'jobtitle': 'Available Positions',
    'jobspagename': 'Join us',
    'jobsdetail': 'Job descriptions',
    'jobsnull': 'Sorry, there are no position available at this time. If you are interested in possible future opportunities, please send your CV to hr@one-asset.com.',

    // Faq
    'faqpagename': 'FAQ',
    'faqtitle': 'FAQ',
    'null': 'Data not found',
    'faq1': 'How to download ONEAM mobile Application for using.',
    'faq1detail': 'Customers can study the download process at <a href="https://www.one-asset.com/th/Benefit/detail/3" target="_blank"> https://www.one-asset.com/th/Benefit/detail/3 </a>',
    'faq2': 'How to use ONE live via website: www.one-asset.com',
    'faq2detail': 'Customers can visit the website.',
    'faq2line1': '1.USERNAME If you can\'t remember, please contact 02-6598888 press 1.',
    'faq2line2': '2. Press Forgot password. The system will let you specify USERNAME. Then, the new password will be sent to your email. Please check your email (Inbox/Junk Mail/SPAM).',
    'faq2line3': '3. Then, go back to the Login page to enter USERNAME and PASSWORD. (recommended to copy USERNAME and PASSWORD, and paste them into specific fields) Note: the new PASSWORD sent by the system will last 15 minutes if you are not logged in within the specified time. you will have to press forgot password again.',
    'faq2line4': '4. When logged in and please set',
    'faq2line4list1': '- Username (Please use 6 or more letters in English characters Uppercase/lowercase/numbers.)',
    'faq2line4list2': '- PASSWORD (Old password: Code sent via e-mail New password, Confirm password: 8 or more letters in uppercase, lowercase, numbers)',
    'faq2line4list3': '- 4-digit PIN, the new password is successfully recorded, press Activated at the email sent to you again within 15 minutes.',
    'faq3': 'How to open an account for new customers.',
    'faq3detail': 'The first fund account can be opened via Application ONEAM or https://onelive.one-asset.com/Home.',
    'faq3line1': '1. Open via Application ONEAM, select CLIENT LOGIN, press OPEN ACCOUNT',
    'faq3line2': '2. Open via <a href="https://onelive.one-asset.com/Home" target="_blank"> https://onelive.one-asset.com/Home </a> Press Apply for an account opening service. Fill in personal information. Identify the marketing officer. Upload a copy of the ID card and a copy of the deposit passbook (first page), and certified true to both copies. Then, the customer will receive USERNAME and PASSWORD which are able to buy funds immediately. Last, the staff will call for interviews to get additional information for account opening.',
    'faq4': 'How to set Auto Buy/Sell price via ONEAM Moblie Application',
    'faq4detail': 'Customers can study the download process at <a href="https://www.one-asset.com/th/Benefit/detail/3" target="_blank"> https://www.one-asset.com/th/Benefit/detail/3 </a>',
    'faq5': 'Direct debit process',
    'faq5detailline1': 'Customers can apply for Direct Debit service by downloading the form at  <a href="https://www.one-asset.com/doc/192504_OR_2_4.pdf" target="_blank"> https://www.one-asset.com/doc/192504_OR_2_4.pdf </a>',
    'faq5detailline2': 'Please fill out the form of Letter of Consent for Direct Debit and certify to both documents by signing the same signature that was given to the bank when opening an account.',
    'faq5detailtitle': 'Attachment',
    'faq5list1': '1. Copy of the ID card (certified true copy) 1 copy.',
    'faq5list2': '2. Copy of the deposit passbook (first page) 1 copy, and certified true copy.',
    'faq5list2line1': 'Send all documents to ONEAM for a bank that can perform direct debit transactions.',
    'faq5list2line2': 'As follows: <a href="https://www.one-asset.com/fund-service-unit" target="_blank"> https://www.one-asset.com/fund-service-unit </a>',
    'faq6': 'How to Buy Fund Gift Card',
    'faq6detailline1': 'Buying Fund Gift Card, customers can call ONEAM Call Center 02-659-8888 press 1.',
    'faq6detailline2': 'or <a href="https://www.one-asset.com/th/Promotion/detail/2" target="_blank"> https://www.one-asset.com/th/Promotion/detail/2 </a>',
    'faq7': 'Please check promotions and privileges via ONEAM Moblie Application.',
    'faq7detailline1': 'Customers can check out promotions and privileges at <a href="https://www.one-asset.com/Promotion/promo" target="_blank"> https://www.one-asset.com/Promotion/promo </a>',
    'faq7detailline2': 'or <a href="https://www.one-asset.com/th/Promotion/detail/2" target="_blank"> https://www.one-asset.com/th/Promotion/detail/2 </a>',
    'faq8': 'Check ONE Points',
    'faq8detailline1': 'Customers can check their ONE Points at ONEAM Moblie Application.',
    'faq8detailtitle': 'Process',
    'faq8list2line1': '1. Login ONEAM Mobile Application',
    'faq8list2line2': '2 Select Menu tab at the top left corner >>> Select tab "Privilege". ',


    // oil
    // contact us

    // header
    'contactusheader': 'Contact Us',

    // title
    'contactustitle1': 'Please fill out the form below, if you have a question or comment.',

    // form
    'contactusform1': 'Name',
    'contactusform2': 'Phone Number',
    'contactusform3': 'Email',
    'contactusform4': 'Topic',
    'contactusform5': 'Detail',
    'contactusform6': 'Please choose topic',
    'contactusform7': 'Fund Information',
    'contactusform8': 'Complaint',
    'contactusform9': 'Other',
    'contactusform10': 'Submit',
    'contactusform11': 'Please specific',

    // form error
    'contactusformerror1': 'Please enter your name',
    'contactusformerror2': 'Please enter your phone number',
    'contactusformerror3': 'Please enter your email',
    'contactusformerror4': 'Please enter a valid email address',
    'contactusformerror5': 'Please specific',
    'contactusformerror6': 'Please enter details',

    // address
    'contactusaddress1': 'One Asset Management Limited',
    'contactusaddress2': 'Siam Piwat Tower, 9th and 24th  Floor, 989',
    'contactusaddress3': 'Rama 1 Road Pathumwan',
    'contactusaddress4': 'Bangkok 10330',

    // detail contact
    'contactusdetail1': 'Buy-Sell Service contact 24th Flooor',
    'contactusdetail2': 'BTS SIAM Exit1',
    'contactusdetail3': '02-659-8888 ext. 1',
    'contactusdetail4': 'Contact our Customer Service',
    'contactusdetail5': '02-659-8860',

    // reply text
    'contactusreply1': 'Thank you,',
    'contactusreply2': 'One Asset Management Limited ',
    'contactusreply3': 'has received your message. The staff will contact you during business hours.',
    'contactusreply4': 'Back to Home',

    // about us

    // header
    'aboutusheader': 'ABOUT US',

    // menu
    'aboutusmenu1': 'OUR HISTORY',
    'aboutusmenu2': 'Board of Directors and Management Team',
    'aboutusmenu3': 'Organizational Chart',

    // topic
    'aboutustopic1': 'OUR HISTORY',
    'aboutustopic2': 'Board of Directors',
    'aboutustopic3': 'Management Team',

    // detail
    'aboutusdetail1': 'One Asset Management Limited was registered as asset management company on 19th March 1992. It is one of the first group of companies which obtained a fund management license from the Ministry of Finance since the Government liberalized investement management under the Securities and Exchange Act. In the present (||yearNow||), One Asset Management Limited has managed investment for ||resultYear|| years providing a full spectrum of management services to clients both inviduals and money institutions, including organizations in public and private sectors. We are also a fast and continuous growing asset management company under the policy of being professional at work, managing an investment with a strategy in accordance with an investment policy that expects good returns within the risk levels appropriate and in accordance with the domestic and international economy situation. One Asset Management Limited also has a determination to  gradually develop our personel to provide the best professional service to investors under our slogan...<br> <b>ACTIVATE OPPORTUNITIES</b>',

    // slogan
    'aboutusslogan1': 'Growth Strivers',
    'aboutusslogan2': 'Innovation Performance',
    'aboutusslogan3': 'Substantial Precision',

    // list name
    'aboutusname1': 'Mr.Chi-Sheng Niu',
    'aboutusname2': 'Ms.Nantarat Surakkhaka',
    'aboutusname3': 'Mr.Pote Harinasuta',
    'aboutusname4': 'Mr.Chin-Lung, Tseng',
    'aboutusname5': 'Ms.Ching Ching Li',
    'aboutusname6': 'Mrs.Yen-Chun, Lin',
    'aboutusname7': 'Mr.Pote Harinasuta',
    'aboutusname8': 'Mr.Krit Pattamavichaiporn',
    'aboutusname9': 'Mr.Monthol Junchaya',
    'aboutusname10': 'Mr.Alongkorn Prathanrasnikorn',
    'aboutusname11': 'Ms.Patamakes Amatyakul ',
    'aboutusname12': 'Mr.Chaiyapruek Kunkanjanathorn',
    'aboutusname13': 'Mr.Sutthiroj Sitiwatananon',
    'aboutusname14': 'Mr.Annop Boonkananurak',
    'aboutusname15': 'Ms.Chidchanok Songsiri',

    // role
    'aboutusrole1': 'Director',
    'aboutusrole2': 'Director',
    'aboutusrole3': 'Director',
    'aboutusrole4': 'Director',
    'aboutusrole5': 'Director and Audit Committee',
    'aboutusrole6': 'Director and Audit Committee',
    'aboutusrole7': 'Chief Executive Officer',
    'aboutusrole8': 'Chief Operating Officer',
    'aboutusrole9': 'Chief Investment Officer',
    'aboutusrole10': 'Chief Property and Trust Officer',
    'aboutusrole11': 'Chief Marketing Officer',
    'aboutusrole12': 'Chief Investment Officer - Domestic',
    'aboutusrole13': 'Chief Investment Officer - Foreign',
    'aboutusrole14': 'Chief Strategy and Operation Officer',
    'aboutusrole15': 'Chief Corporate Officer',

    // fund service unit

    // header
    'fundunitheader': 'Service Channels',

    // button
    'fundunitdownloadbtn': 'Download Forms',
    'fundopenaccountpine': 'Open Account Online with Subsidiaries',
    'fundopenaccountpineheader': 'Open Account Online',
    'fundopenaccountpinemodal': 'From October 1, 2023 onwards, One Asset Management Limited (ONEAM) will change an online account opening channel. Investors who wish to open a new fund account via an online channel will be required to do so at Pine Wealth Solution Securities Company Limited, a subsidiary of ONEAM, instead.',

    // contact
    'fundunitcontact1': 'For those who are interesed in investment under the management of One Asset Management Limited, please contact us for more information to receive investment service at One Asset Management Limited Tel. 02-659-8888 press 1 or at any selling agent appointed by One Asset Management Limited.',

    // topic
    'fundunittopic1': 'Initial unit subscription',
    'fundunittopic2': 'Redemptions',
    'fundunittopic3': 'Money Transfer for subscription',

    // detail topic
    'fundunitdetailtopic1': 'A new investor can open the following accounts with One Asset Management Limited',
    'fundunitdetailtopic2': 'To receive redemptions and/or dividends in a bank account, please provide a copy of the first page of deposit passbook with certified true copy. There are 13 banks that can accept receipt of redemption payment as follows:',
    'fundunitdetailtopic3': 'Please transfer money to Open End Fund Subscription Account for One Asset Management Limited as following.',

    // title
    'fundunittitle1': 'To open a general account',
    'fundunittitle2': 'Minor',

    // detail title1
    'fundunittitle1detail1': 'fill in information and provide the following documents:',
    'fundunittitle1detail2': 'Open-end Fund Account Opening Form',
    'fundunittitle1detail3': 'Suitability Test',
    'fundunittitle1detail4': 'Identification Document',
    'fundunittitle1detail5': 'Invidual',
    'fundunittitle1detail6': '- Identification Card/Passport/Alien Identification Card',
    // "fundunittitle1detail7": "- House registration specifying an identification number",
    'fundunittitle1detail8': '- If a foreigner holds a work permit or visa, it is required to be valid for more than 3 months ',
    'fundunittitle1detail9': 'Juristic Person ',
    'fundunittitle1detail10': '- Certificate of Registration issued by a registrar within the past 3 months',
    'fundunittitle1detail11': '- Identification Card/Passport/Alien Identification Card of Company\'s Authorized',
    // "fundunittitle1detail12": "- Identification Card/Government Official Identification Card/Passport/Alien Identification Card/other cards issued by the official ",
    'fundunittitle1detail13': '- A copy of the List of Shareholders (Bor.Aor.Jor.5) (with certified true copy) ',
    'fundunittitle1detail14': '- Minutes of the meeting or letter of intent expressing an intention to open an account or enter into a transaction ',
    'fundunittitle1detail15': 'A copy of deposit passbook (first page)',

    // detail title2
    'fundunittitle2detail1': 'fill in information and provide the following documents:',
    'fundunittitle2detail2': 'Over 15 year-old minor can open an account  by himself or herself by attaching a copy of identification card/Passport/Alien Identification Card (with certified true copy by the card owner)',
    'fundunittitle2detail3': 'Under 15 year-old minor, parents (father and mother) or a legal representative has to sign a name and attach the additional documents as follows:',
    'fundunittitle2detail4': 'a copy of birth certification of a minor (certified true copy by parents/legal repretative and minor) ',
    'fundunittitle2detail5': 'a copy of house registration showing a name of a minor as a resident (certified true copy by parents/legal representative and minor)',
    // "fundunittitle2detail6": "a copy of identification card/Passport/Alien Identification Card (with certified true copy by the card owner)",
    'fundunittitle2detail6': 'a copy of identification card/Passport/Alien Identification Card of a father and mother or a legal representative (with certified true copy by the card owner)',
    // detail topic2
    'fundunittopic2detail1': 'Bank of Ayudhya Public Company Limited',
    'fundunittopic2detail2': 'Bangkok Bank Public Company Limited ',
    'fundunittopic2detail3': 'CIMB Thai Bank Public Company Limited ',
    'fundunittopic2detail4': 'Government Savings Bank',
    'fundunittopic2detail5': 'Kasikorn Bank Public Company Limited',
    'fundunittopic2detail6': 'Kiatnakin Phatra Bank Public Company Limited',
    'fundunittopic2detail7': 'Krung Thai Bank Public Company Limited',
    'fundunittopic2detail8': 'Land and Houses Bank Public Company Limited',
    'fundunittopic2detail9': 'Siam Commercial Bank Public Company Limited',
    // "fundunittopic2detail10": "Thanachart Bank Public Company Limited",
    'fundunittopic2detail10': 'Thai Credit Retail Bank Public Company Limited',
    'fundunittopic2detail11': 'TISCO Bank Public Company Limited',
    'fundunittopic2detail12': 'TMBThanachart Bank Public Company Limited',
    'fundunittopic2detail13': 'UOB Bank Public Company Limited',

    // head table
    'fundunittablehead1': 'Account Name',
    'fundunittablehead2': 'Bank',
    'fundunittablehead3': 'Branch',
    'fundunittablehead4': 'Account Type',
    'fundunittablehead5': 'Account Number',

    // row detail
    // row1
    'fundunitrow1detail1': 'Open End Fund Subscription Account for One Asset Management Limited',
    'fundunitrow1detail2': 'Krungsri Ayudhya',
    'fundunitrow1detail3': 'Siam Square',
    'fundunitrow1detail4': 'Current Account',
    'fundunitrow1detail5': '123-0-03671-7',

    // row2
    'fundunitrow2detail1': 'Open End Fund Subscription Account for One Asset Management Limited',
    'fundunitrow2detail2': 'Bangkok',
    'fundunitrow2detail3': 'Siam Square',
    'fundunitrow2detail4': 'Current Account',
    'fundunitrow2detail5': '152-3-11123-3',

    // row3
    'fundunitrow3detail1': 'Open End Fund Subscription Account for One Asset Management Limited',
    'fundunitrow3detail2': 'CIMB Thai',
    'fundunitrow3detail3': 'Silom Office',
    'fundunitrow3detail4': 'Current Account',
    'fundunitrow3detail5': '800-0-19697-3',

    // row4
    'fundunitrow4detail1': 'Open End Fund Subscription Account for One Asset Management Limited',
    'fundunitrow4detail2': 'GSB',
    'fundunitrow4detail3': 'Siam Square One',
    'fundunitrow4detail4': 'Current Account',
    'fundunitrow4detail5': '000-000-445-072',

    // row5
    'fundunitrow5detail1': 'Open End Fund Subscription Account for One Asset Management Limited',
    'fundunitrow5detail2': 'Kasikorn Thai',
    'fundunitrow5detail3': 'Siam Square',
    'fundunitrow5detail4': 'Current Account',
    'fundunitrow5detail5': '026-1-09287-5',

    // row6
    'fundunitrow6detail1': 'Open End Fund Subscription Account for One Asset Management Limited',
    'fundunitrow6detail2': 'Kiatnakin Phatra',
    'fundunitrow6detail3': 'Central World',
    'fundunitrow6detail4': 'Current Account',
    'fundunitrow6detail5': '100-0-00238-2',

    // row7
    'fundunitrow7detail1': 'Open End Fund Subscription Account for One Asset Management Limited',
    'fundunitrow7detail2': 'Krung Thai',
    'fundunitrow7detail3': 'Siam Square',
    'fundunitrow7detail4': 'Current Account',
    'fundunitrow7detail5': '052-6-08671-8',

    // row8
    'fundunitrow8detail1': 'Open End Fund Subscription Account for One Asset Management Limited',
    'fundunitrow8detail2': 'Land and Houses',
    'fundunitrow8detail3': 'Lumpini Office',
    'fundunitrow8detail4': 'Current Account',
    'fundunitrow8detail5': '889-1-01067-2',

    // row9
    'fundunitrow9detail1': 'Open End Fund Subscription Account for One Asset Management Limited',
    'fundunitrow9detail2': 'SCB',
    'fundunitrow9detail3': 'Siam Square',
    'fundunitrow9detail4': 'Current Account',
    'fundunitrow9detail5': '038-3-07483-3',

    // row10
    'fundunitrow10detail1': 'Open End Fund Subscription Account for One Asset Management Limited',
    'fundunitrow10detail2': 'Thanachart',
    'fundunitrow10detail3': 'Siamkit Building',
    'fundunitrow10detail4': 'Current Account',
    'fundunitrow10detail5': '044-3-00149-5',

    // row11
    'fundunitrow11detail1': 'Open End Fund Subscription Account for One Asset Management Limited',
    'fundunitrow11detail2': 'TCR',
    'fundunitrow11detail3': 'Ratchadaphisek Office',
    'fundunitrow11detail4': 'Current Account',
    'fundunitrow11detail5': '777-1-00500-6',

    // row12
    'fundunitrow12detail1': 'Open End Fund Subscription Account for One Asset Management Limited',
    'fundunitrow12detail2': 'TISCO',
    'fundunitrow12detail3': 'Head Office',
    'fundunitrow12detail4': 'Current Account',
    'fundunitrow12detail5': '0001-114-005061-0',

    // row13
    'fundunitrow13detail1': 'Open End Fund Subscription Account for One Asset Management Limited',
    'fundunitrow13detail2': 'TTB',
    'fundunitrow13detail3': 'Phahonyothin Office',
    'fundunitrow13detail4': 'Current Account',
    'fundunitrow13detail5': '001-1-54342-8',

    // row14
    'fundunitrow14detail1': 'Open End Fund Subscription Account for One Asset Management Limited',
    'fundunitrow14detail2': 'UOB',
    'fundunitrow14detail3': 'Siam Square',
    'fundunitrow14detail4': 'Current Account',
    'fundunitrow14detail5': '772-3-63112-6',

    // bottomdetail
    'fundunitbottomdetail1': 'After you transfer money by any means as mentioned above, please fill in a subscription form and also attach a copy of money tranfer receipt, then send them by fax to Customer Service and Marketing Support, Fax No. 02-659-8860-1. If you are not convenient to do so, please contact our officer at',
    'fundunitbottomdetail2': 'Tel. No. 02-659-8888 press 1 ',
    'fundunitbottomdetail3': 'Customer Service and Marketing Support',
    'fundunitbottomdetail4': 'The company will send our officer to pick up a subscription form and a cheque directly from you.',
    'fundunitbottomdetail5': 'For more convenience in',
    'fundunitbottomdetail6': 'ordering unit trusts regularly (Standing Instruction),',
    'fundunitbottomdetail7': 'the company currently offers a unit holder to apply a direct debit through 12 banks as follows: ',

    // list banks
    'fundunitlistbank1': 'Bank of Ayudhya Public Company Limited',
    'fundunitlistbank2': 'Bangkok Bank Public Company Limited',
    'fundunitlistbank3': 'CIMB Thai Bank Public Company Limited',
    'fundunitlistbank4': 'Kasikorn Bank Public Company Limited',
    'fundunitlistbank5': 'Kiatnakin Phatra Bank Public Company Limited',
    'fundunitlistbank6': 'Krung Thai Bank Public Company Limited',
    'fundunitlistbank7': 'Land and Houses Bank Public Company Limited',
    'fundunitlistbank8': 'Siam Commercial Bank Public Company Limited',
    // "fundunitlistbank9": "Thanachart Bank Public Company Limited",
    'fundunitlistbank9': 'Thai Credit Retail Bank Public Company Limited',
    'fundunitlistbank10': 'TISCO Bank Public Company Limited',
    'fundunitlistbank11': 'TMBThanachart Bank Public Company Limited',
    'fundunitlistbank12': 'UOB Bank Public Company Limited',

    // summary
    'fundunitsummary1': 'You only need to fill a direct debit subscription form and also attach a copy of a deposit passbook which you would like  us to make deduction from, then submit the documents to Client Relations and Supporting Business of the company. When the company is approved by the account owner\'s bank, the company will further inform you. The process will take approximately 1 month.',
    'fundunitsummary2': 'Remarks',
    'fundunitsummary3': ': At present, the company will automatically deduct money from account only every 1st and 16th of the month.',

    // download form (fund service unit)
    'downloadfromunitheader': 'Download form',


    // Plan Your Investment

    // header
    'planinvestmentheader': 'Plan Your Investment',

    // menu
    'planinvestmentmenu1': 'Learn about Investment',
    'planinvestmentmenu2': 'How to Invest',
    'planinvestmentmenu3': 'Asset Allocation',

    // step topic
    'planinvestmentsteptopic1': 'Step 1: Choose your GOAL',

    // target title
    'planinvestmenttargettitle1': 'NEW INVESTOR',
    'planinvestmenttargettitle2': 'INVESTMENT TARGET',
    'planinvestmenttargettitle3': 'RETIREMENT',

    // target description
    'planinvestmenttargetdesc1': 'Financial planning and preparing for New Investor',
    'planinvestmenttargetdesc2': 'Financial planning and preparing for achieving financial Goal',
    'planinvestmenttargetdesc3': 'Financial planning and preparing for retirement spending',

    // Investing By Risk

    // Newbee
    'investingbyrisknewbee': 'Name - Surname',

    // Topic
    'investingbyrisktopic': 'Risk-taking capabilities test ',

    // Note
    'investingbyrisknote1': 'Please answer all questions,',
    'investingbyrisknote2': 'to assess suitability of an investment in accordance with an acceptable risk.',
    'investingbyrisknoteerror': 'Please complete the form',

    // Q&A
    // 1
    'investingbyriskquestion1': 'Currently, you are',
    'investingbyriskq1answer1': 'over 55 years',
    'investingbyriskq1answer2': '45-55 years',
    'investingbyriskq1answer3': '35-44 years',
    'investingbyriskq1answer4': 'below 35 years',

    // 2
    'investingbyriskquestion2': 'What is the current ratio of your financial obligations and regular expense such as mortgage payment, car payment, personal expense, and family expense, to your income?',
    'investingbyriskq2answer1': 'Over 75% of total income',
    'investingbyriskq2answer2': 'Between 51– 75% of total income',
    'investingbyriskq2answer3': 'Between 25 – 50% of total income',
    'investingbyriskq2answer4': 'Less than 25% of total income',

    // 3
    'investingbyriskquestion3': 'What is your current financial status?',
    'investingbyriskq3answer1': 'Less assets than debts',
    'investingbyriskq3answer2': 'Asset equal to debts',
    'investingbyriskq3answer3': 'More assets than debts',
    'investingbyriskq3answer4': 'I will have adequate saving/investments througout my retirement',

    // 4
    'investingbyriskquestion4': 'Which is the following assets do you have investment experience with or knowledge about? (You can choose more than one answer.)',
    'investingbyriskq4answer1': 'Bank Deposit',
    'investingbyriskq4answer2': 'Government Bond or Government Bond Fund',
    'investingbyriskq4answer3': 'Debentures or Fixed Income Fund',
    'investingbyriskq4answer4': 'Equity Stock or Equity Fund or other High-Risk Assets',
    'investingbyriskq4note': 'If you have more than one answer, please choose the answer with the highest score.',

    // 5
    'investingbyriskquestion5': 'The estimated period that you will not need to use your invested fund',
    'investingbyriskq5answer1': 'Less than 1 year',
    'investingbyriskq5answer2': '1-3 years',
    'investingbyriskq5answer3': '3--5 years',
    'investingbyriskq5answer4': 'More than 5 years',

    // 6
    'investingbyriskquestion6': 'What is your investment objective?',
    'investingbyriskq6answer1': 'Focus on opportunity in preserving original investment safely and receiving small consistent return',
    'investingbyriskq6answer2': 'Focus on opportunity in receiving consistent return but may take risk of losing some original investment',
    'investingbyriskq6answer3': 'Focus on opportunity in receiving higher return but may take risk of losing more original investment',
    'investingbyriskq6answer4': 'Focus on the highest long-term return but may take risk of losing most of the original investment',

    // 7
    'investingbyriskquestion7': 'When considering sample picture below showing the potential returns of different investment portfolio, which investment portfolio are you most willing to invest in?',
    'investingbyriskq7answer1': 'Investment portfolio 1 (has chance to receive 2.5% return without any loss)',
    'investingbyriskq7answer2': 'Investment portfolio 2 (has chance to receive 7% highest return but may lose up to 1%)',
    'investingbyriskq7answer3': 'Investment portfolio 3 (has chance to receive 15% highest return but may lose up to 5%)',
    'investingbyriskq7answer4': 'Investment portfolio 4 (has chance to receive 25% highest return but may lose up to 15%)',

    // 8
    'investingbyriskquestion8': 'If you were to invest in high-return assets, but also have chances to receive high loss, how would you feel?',
    'investingbyriskq8answer1': 'Worried and afraid of loss',
    'investingbyriskq8answer2': 'Uneasy but somehow understand',
    'investingbyriskq8answer3': 'Understand and accept certain degree of fluctuation',
    'investingbyriskq8answer4': 'Not concerned about high-risk loss, and expect that the return may increase',

    // 9
    'investingbyriskquestion9': 'You would be worried or unwilling to accept a scenario where your investment diminishes by:',
    'investingbyriskq9answer1': '5% or less',
    'investingbyriskq9answer2': 'Over 5% -10%',
    'investingbyriskq9answer3': 'Over 10% -20%',
    'investingbyriskq9answer4': 'Over 20%',

    // 10
    'investingbyriskquestion10': 'What would you do if you invested 100,000 Baht last year, but the value of your investment declines to 85,000 Baht this year?',
    'investingbyriskq10answer1': 'Panic and want to sell the remaining investment',
    'investingbyriskq10answer2': 'Worried and shift some investments to lower-risk assets',
    'investingbyriskq10answer3': 'Continue holding the investment and wait until the investment rebounds',
    'investingbyriskq10answer4': 'Remain confident since it is long-term investment, and invest more in the same asset type to average costs',

    // 11
    'investingbyriskq11note1': 'For investment in derivatives',
    'investingbyriskq11note2': '(Questions 11-12 are used as additional information for guidance)',
    'investingbyriskquestion11': 'Successfully investing in derivatives and structure notes offers exceptionally high returns, but failure will probably lead to total loss where additional funds may be required to cover such loss. Are you willing to accept such an outcome?',
    'investingbyriskq11answer1': 'No',
    'investingbyriskq11answer2': 'Yes, but only to a certain extent',
    'investingbyriskq11answer3': 'Yes',

    // 12
    'investingbyriskq12note': 'For overseas investment',
    'investingbyriskquestion12': 'In addition to the risk of investment, are you able to accept foreign exchange rate risk?',
    'investingbyriskq12answer1': 'No',
    'investingbyriskq12answer2': 'Yes, but only to a certain extent',
    'investingbyriskq12answer3': 'Yes',

    // sumary
    'investingbyrisksumary': 'GET THE RESULTS',

    // calculate step2
    // step topic
    'step2topic1': 'The result conquers your financial goals.',

    // title
    'step2title1': 'Summarize the results according to your goals.',
    'step2title2': 'Your savings goals.',
    'step2title3': 'Investing to achieve your goals',
    'step2title4': 'Terms of Service',

    // detail
    // title1
    // column 1
    'step2t1col1detail1': 'You have time to invest ',
    'step2t1col1detail2': ' years.',
    'step2t1col1detail3': 'by spending after retirement ',
    'step2t1col1detail4': ' years.',

    // column 2
    'step2t1col2detail1': 'If you plan to spend after retirement ',
    'step2t1col2detail2': ' baht / month,',
    'step2t1col2detail3': 'you should have savings when you retire ',
    'step2t1col2detail4': ' baht.',
    'step2t1col2detail5': 'From your current savings, if you invest in recommended Funds by ONEAM, the expected return on retirement is ',
    'step2t1col2detail6': ' baht.',

    // column 3
    'step2t1col3detail1': 'To achieve',
    'step2t1col3detail2': 'your retirement saving goals, you should generate a return on investment ',
    'step2t1col3detail3': ' baht, which is equal to the return at ',
    'step2t1col3detail5': '%, so that it is sufficient for future expenses. Recommend ',
    'step2t1col3detail4': ' Diversification that ',

    // title2
    // column 1
    'step2t2col1detail1': 'You have savings ',
    'step2t2col1detail2': ' Baht.',

    // column 2
    'step2t2col2detail1': 'Your savings goals ',
    'step2t2col2detail2': ' Baht.',

    // column 3
    'step2t2col3detail1': 'You need ',
    'step2t2col3detail2': ' Baht. for more saving.',

    // column 4
    'step2t2col4detail1': 'or saving money per month ',
    'step2t2col4detail2': ' Baht.',

    // title3
    'step2t3detail1': 'List of recommended funds for you. The expected return on investment approximately ',
    'step2t3detail2': ' by investing ',
    'step2t3detail3': ' baht per month.',
    'step2t3detail4': 'Recommended Funds',

    // remark
    'step2remark1': 'Red: The risk level of this fund is higher than the risk level that you can accept from your investment suitability assessment form. Please acknowledge the additional fund risks before confirming the investment.',
    'step2remark2': 'Blue: This fund is a tax benefit fund. Before investing, investors are advised to study the tax incentives stated in the Investment Manual.',

    // subtitle
    'step2subtitle1': 'Disclaimer of use',
    'step2subtitle1detail': 'This retirement model is created for the purpose of understanding the retirement saving plan only. The return on investment may change under certain conditions. Past performance is not a guarantee of future performance. Investments contain risks. Investors should study information before making investment decisions. Historical calculations are not included in the fee and may result in an invalid return on investment. We are not responsible for any returns, lost, or damage from the use of this information or the presentation of this information.',

    'step2subtitle2': 'This calculation model is subject to the following assumptions.',
    'step2subtitle2detail1': 'The expected return is calculated based on historical data from 2005 - 2015 of ONEAM’s mutual fund in each asset class. If there is no historical data, the appropriate benchmark for each asset class will be used instead.',
    'step2subtitle2detail2': 'Showing the probability of success in an investment upon retirement. The probability is calculated by assuming that a normal investment value uses the mean of the future value of the investment money at retirement and the standard deviation.',
    'step2subtitle2detail3': 'Investment risk is measured by the volatility of the investment plan.',
    'step2subtitle2detail4': 'Usually, the distribution of return is not taken into account for the present value and future value.',

    // button
    'step2button': 'Ask for advice from our staff.',

    // calculate step3
    // header
    'step3header': 'Plan Your Investment',

    // topic
    'step3topic1': 'Please fill in your information.',
    'step3topic2': 'To receive investment planning advice.',

    // information
    'step3info1': 'Name',
    'step3info2': 'Surname',
    'step3info3': 'Phone Number',
    'step3info4': 'E-mail',

    // error msg
    'step3error1': 'Please enter your name',
    'step3error2': 'Please enter your phone number',
    'step3error3': 'Please enter a valid phone number.',

    // button
    'step3backbtn': 'Back',
    'step3comfirmbtn': 'Confirm',

    // alert msg
    'step3msg1': 'Thank you, ',
    'step3msg2': 'One Asset Management Limited has received your message.',
    'step3msg3': 'The staff will contact you during business hours.',

    // Fund Detail TH
    // Morning Star
    'funddetailthmorning1': 'A star from Morning Star',
    'funddetailthmorning2': 'At date',

    // header button
    'funddetailthheaderbtn1': 'FUND COMPARE',
    'funddetailthheaderbtn2': 'TRADE',

    // menu
    // not trust, etf
    'funddetailthmenu1': 'FUND DETAIL',
    'funddetailthmenu2': 'Performance',
    'funddetailthmenu3': 'Subscription/Redemption',

    // trust, etf
    'funddetailthmenu4': 'REIT DETAILS',
    'funddetailthmenu5': 'Performance',
    'funddetailthmenu6': 'Trading REIT unit',
    'funddetailthmenu35': 'Trading unit trust',

    // is etf
    'funddetailthmenu7': 'FUND DETAIL',
    'funddetailthmenu8': 'Performance',
    'funddetailthmenu9': 'Subscription/Redemption',
    'funddetailthmenu10': 'Price / Stock basket price',

    // usd
    'funddetailthmenu11': 'Investment unit trading',
    'funddetailthmenu12': 'Price and PDF Report',
    'funddetailthmenu13': 'Unit Price (USD)',
    'funddetailthmenu14': 'As of',
    'funddetailthmenu15': 'Ask price/Switch to',
    'funddetailthmenu16': 'Ask price/Switch to',
    'funddetailthmenu17': 'Net Asset Value',
    'funddetailthmenu18': 'Dividend Payment Policy',
    'funddetailthmenu19': 'Unit Price',
    'funddetailthmenu20': 'Rewards',
    'funddetailthmenu21': 'Investment Objective',
    'funddetailthmenu22': 'Investment Focus',
    'funddetailthmenu23': 'Product Suitability',
    'funddetailthmenu24': 'Generald Information',
    'funddetailthmenu25': 'Fund Type',
    'funddetailthmenu26': 'Investment Policy',
    'funddetailthmenu27': 'Fund Code',
    'funddetailthmenu28': 'Registrar',
    'funddetailthmenu29': 'Fund Supervisor',
    'funddetailthmenu30': 'Inception Date',
    'funddetailthmenu31': 'Accounting Period',
    'funddetailthmenu32': 'Investment Portfolio',
    'funddetailthmenu33': 'Asset Allocation',
    'funddetailthmenu34': 'Top 5 Holdings',

    // menu 1
    // detail not trust, prop
    // block 1
    'funddetailthm1b1detail1': 'NAV',
    'funddetailthm1b1detail2': 'At date',
    'funddetailthm1b1detail3': 'Offer/Switch-in Price',
    'funddetailthm1b1detail4': 'Bid/Switch-out Price',
    'funddetailthm1b1detail5': 'Net Asset Value',
    'funddetailthm1b1detail6': 'Total Asset Value',

    // block 2
    'funddetailthm1b2detail1': 'Dividend Policy',

    // block 3
    'funddetailthm1b3detail1': 'NAV',

    // block 4
    'funddetailthm1b4detail1': 'Award',
    'funddetailthm1b4detail2': 'Investment Objective',
    'funddetailthm1b4detail3': 'Investment Style',
    'funddetailthm1b4detail4': 'Suitable for what kind of investors',

    // block 7
    'funddetailthm1b7detail1': 'Portfolio',
    'funddetailthm1b7detail1_asofdate': 'As of',
    'funddetailthm1b7detail2': 'Asset Allocation',
    'funddetailthm1b7detail3': 'Top 5 Holdings',

    // detail is trust
    // block 1
    'funddetailthm1b1detail7': 'Unit Trust',
    'funddetailthm1b1detail8': 'At date',
    'funddetailthm1b1detail9': 'Net Asset Value',
    'funddetailthm1b1detail10': 'Total Asset Value',

    // block 2
    'funddetailthm1b2detail2': 'Distribution Payment Policy',

    // detail is prop
    // block 1
    'funddetailthm1b1detail11': 'NAV',
    'funddetailthm1b1detail12': 'At date',
    'funddetailthm1b1detail13': 'Net Asset Value',
    'funddetailthm1b1detail14': 'Total Asset Value',

    // block 2
    'funddetailthm1b2detail3': 'Dividend Policy',

    // block 5
    'funddetailthm1b5detail1': 'Fund Detail',
    'funddetailthm1b5detail2': 'Type of REIT',
    'funddetailthm1b5detail3': 'Fund Type',
    'funddetailthm1b5detail4': 'Fund Policy',
    'funddetailthm1b5detail5': 'REIT Code',
    'funddetailthm1b5detail6': 'Fund Code',
    'funddetailthm1b5detail7': 'Registrar',
    'funddetailthm1b5detail8': 'Trustee',
    'funddetailthm1b5detail9': 'Trustee',
    'funddetailthm1b5detail10': 'Inception date',
    'funddetailthm1b5detail11': 'Fiscal year',
    'funddetailthm1b5detail12': 'Accounting Period Ending',
    'funddetailthm1b5detail13': 'Established',
    'funddetailthm1b5detail14': 'Investment policy',

    // block 6
    'funddetailthm1b6detail1': 'Download Documents',
    // menu 2
    // detail not trust, prop
    // block 1
    'funddetailthm2b1detail1': 'Previous Fund Performance',
    'funddetailthm2b1detail2': 'Since Inception',

    // block 2
    'funddetailthm2b2detail1': 'Previous 3 months NAV',
    // head table
    'funddetailthm2b2detail2': 'Date',
    'funddetailthm2b2detail3': 'NAV (THB/UNIT)',
    'funddetailthm2b2detail4': 'OFFER (THB/UNIT)',
    'funddetailthm2b2detail5': 'BID (THB/UNIT)',
    'funddetailthm2b2detail6': 'Net Asset Value (THB)',
    'funddetailthm2b2detail7': 'Total Asset Value (THB)',

    // detail is trust
    // block 2
    'funddetailthm2b3detail8': 'Historical unit trust value',
    // head table
    'funddetailthm2b2detail9': 'Date',
    'funddetailthm2b2detail10': 'NAV (THB/UNIT)',
    'funddetailthm2b2detail11': 'Net Asset Value (THB)',
    'funddetailthm2b2detail12': 'Total Asset Value (THB)',

    // detail is prop
    // block 2
    'funddetailthm2b3detail13': 'NAV Since inception',
    // head table
    'funddetailthm2b2detail14': 'Date',
    'funddetailthm2b2detail15': 'NAV (THB/UNIT)',
    'funddetailthm2b2detail16': 'Net Asset Value (THB)',
    'funddetailthm2b2detail17': 'Total Asset Value (THB)',

    // detail is Deviden
    // block 2
    'funddetailthm2b3detail18': 'Dividend history Since inception',
    'funddetailthm2b3detail19': 'Download',
    // head table 1
    'funddetailthm2b2detail20': 'Times',
    'funddetailthm2b2detail21': 'Fund Code',
    'funddetailthm2b2detail22': 'Dividend amount (Baht / unit)',
    'funddetailthm2b2detail23': 'Book closing date',
    'funddetailthm2b2detail24': 'Pay date',

    // head table 2
    'funddetailthm2b2detail25': 'Times',
    'funddetailthm2b2detail26': 'Dividend amount (Baht / unit)',
    'funddetailthm2b2detail27': 'Book closing date',
    'funddetailthm2b2detail28': 'Pay date',

    // new trust detail
    'funddetailthm2b3detail29': 'Distribution Payment',


    // block 3
    'funddetailthm2b3detail1': 'INVESTMENT CALCULATOR',
    'funddetailthm2b3detail2': 'CALCULATION TOOL THAT WILL HELP YOU CALCULATE THE INVESTMENT EASILY, QUICKLY, AND CONVENIENTLY.',

    // block 4
    'funddetailthm2b4detail1': 'FUND PERFORMANCE',
    'funddetailthm2b4detail2': 'PLEASE CHECK THE FUND PERFORMANCE HERE',

    // menu 3
    // detail not trust, StoxxUSD, etf, prop
    // block 1
    'funddetailthm3b1detail1': 'Subscription/Redemption',
    'funddetailthm3b1detail2': 'Subscription',
    'funddetailthm3b1detail3': 'Minimum initial subscription',
    'funddetailthm3b1detail4': 'Baht',
    'funddetailthm3b1detail5': 'Minimum subsequent subscription',
    'funddetailthm3b1detail6': 'FUND GIFT CARD MINIMUM',
    'funddetailthm3b1detail7': 'Subscription Period',
    // button
    'funddetailthm3b1detail8': 'OPEN ACCOUNT ONLINE',
    'funddetailthm3b1detail9': 'TRADE',
    'funddetailthm3b1detail25': 'USD',

    // block 2
    'funddetailthm3b2detail1': 'Redemption',
    'funddetailthm3b2detail2': 'Minimum holding unit balance',
    'funddetailthm3b2detail3': 'Units',
    'funddetailthm3b2detail4': 'Redemption',
    'funddetailthm3b2detail5': 'Minimum holding investment balance',
    'funddetailthm3b2detail6': 'Redemption Period',
    'funddetailthm3b2detail7': 'Settlement Period',
    'funddetailthm3b2detail8': '',
    'funddetailthm3b2detail9': 'Business days after the date of redemption',
    'funddetailthm3b2detail10': '',

    // detail is etf
    // block 1
    'funddetailthm3b1detail10': 'Trading method',
    'funddetailthm3b1detail11': 'For participating dealers',
    'funddetailthm3b1detail12': 'They can purchase investment units directly with the Management Company at least 1 unit at a time and multiply by using the price on the day of submission of the order for the investment unit which uses a stock basket price as specified by the management company.',
    'funddetailthm3b1detail13': 'For investors, ',
    'funddetailthm3b1detail14': 'For investors or participating dealers can purchase ETF funds on the Stock Exchange of Thailand by complying with the rules and regulations of the Stock Exchange of Thailand. Investors must have a securities trading account with a securities company.',
    'funddetailthm3b1detail15': 'Investors can purchase investment units by the basket stock price method with participating dealers',
    'funddetailthm3b1detail16': 'In which trading processes are specified by the participating dealers.',
    'funddetailthm3b1detail17': 'Trading hours',
    'funddetailthm3b1detail18': 'Every business day of the Stock Exchange of Thailand.',
    'funddetailthm3b1detail19': 'Not required',

    // detail is trust, prop
    // block 1
    'funddetailthm3b1detail20': 'Trading method',
    'funddetailthm3b1detail21': 'For investors or participating dealers can purchase ETF funds on the Stock Exchange of Thailand by complying with the rules and regulations of the Stock Exchange of Thailand. Investors must have a securities trading account with a securities company.',
    'funddetailthm3b1detail22': 'Investors can purchase investment units by the basket stock price method with participating dealers',
    'funddetailthm3b1detail23': 'In which trading processes are specified by the participating dealers.',
    'funddetailthm3b1detail24': 'For investors or participating dealers can purchase unit trust on the Stock Exchange of Thailand by complying with the rules and regulations of the Stock Exchange of Thailand. Investors must have a securities trading account with a securities company.',

    // detail not trust, prop
    // block 3
    'funddetailthm3b3detail1': 'Subscription/Redemption Fee',
    'funddetailthm3b3detail2': 'Fees',
    'funddetailthm3b3detail3': '(% of NAV)',

    'funddetailthm3b3detail4': 'Front-end Fee',
    'funddetailthm3b3detail5': 'Back-end Fee',
    'funddetailthm3b3detail6': 'Switching-in Fee',
    'funddetailthm3b3detail7': 'Switching-out Fee',

    'funddetailthm3b3detail8': 'Fees charge from Fund',
    'funddetailthm3b3detail9': '(% of Total Asset Value of Fund including VAT)',
    'funddetailthm3b3detail10': 'Registrar Fee',
    'funddetailthm3b3detail11': 'Management Fee',
    'funddetailthm3b3detail12': 'Trustee Fee',
    'funddetailthm3b3detail13': 'OTHER',
    'funddetailthm3b3detail14': 'TOTAL',

    'funddetailthm3b3detail15': 'Fees',
    'funddetailthm3b3detail16': 'Fees charged from the REIT',
    'funddetailthm3b3detail17': '(% Of total asset value of the REIT, excluding VAT)',
    'funddetailthm3b3detail18': 'Registrar Fee',
    'funddetailthm3b3detail19': 'Management Fee',
    'funddetailthm3b3detail20': 'Trustee Fee',
    'funddetailthm3b3detail21': 'OTHER',
    'funddetailthm3b3detail22': 'TOTAL',

    'funddetailthm3b3detail23': 'Subscription/Redemption Fee',
    'funddetailthm3b3detail24': 'Fees charge from Fund',
    'funddetailthm3b3detail25': '(% Of total asset value of the fund, including VAT)',
    'funddetailthm3b3detail26': 'Registrar Fee',
    'funddetailthm3b3detail27': 'Management Fee',
    'funddetailthm3b3detail28': 'Trustee Fee',
    'funddetailthm3b3detail29': 'OTHER',
    'funddetailthm3b3detail30': 'TOTAL',

    // block 4
    'funddetailthm3b4detail1': 'Calendar of trading days / fund holidays',

    // block 5
    'funddetailthm3b5detail1': 'Subscription/Redemption CHANNEL',
    'funddetailthm3b5detail2': 'You can subscription/redemption as follow',
    'funddetailthm3b5detail3': 'Able to trade by opening a trading account with a securities company',

    // detail not openTop, trust, prop
    'funddetailthm3b5detail4': 'Subscription/Redemption ',
    'funddetailthm3b5detail5': 'Online easily',
    'funddetailthm3b5detail6': 'One Asset',
    'funddetailthm3b5detail8': 'Management Limited',
    'funddetailthm3b5detail7': 'Contact',

    // block 6
    // detail is hasSupporter
    'funddetailthm3b6detail1': 'The Appointed Selling Agents ',
    'funddetailthm3b6detail2': 'or Sales Support Agents',
    // menu 4
    // is etf
    'funddetailthm4detail1': 'Price',
    'funddetailthm4detail2': 'At date',
    'funddetailthm4detail3': 'Number of shares',
    'funddetailthm4detail4': 'INFORMATION AS OF',
    'funddetailthm4detail5': 'Download PDF',
    'funddetailthm4detail6': 'Download BA/NAV',
    'funddetailthm4detail7': 'Share',
    'funddetailthm4detail8': 'BID',
    'funddetailthm4detail9': '(THB/UNIT)',
    'funddetailthm4detail10': 'Amount (baht)',
    'funddetailthm4detail11': 'The value of the PDF is the value of TDEX of 1 CU (Creation Unit) or equal to 1,000,000 units.',

    // sumModal
    'funddetailthsummodal1': 'Warning',
    'funddetailthsummodal2': 'Past performance is not a guarantee of future performance.',
    'funddetailthsummodal3': 'Evaluation of a Mutual Fund is prepared and conducted pursuant to the evaluation standard prescribed by AIMC.',
    'funddetailthsummodal4': 'The calculation of the rate of return is calculated without deducting the trading fee.',
    'funddetailthsummodal5': 'Show Annualized returns if more than 1 year',
    'funddetailthsummodal6': 'The adjustment frequency of Composite Benchmark\'s weight is calculated daily.',
    'funddetailthsummodal7': 'Calculation of fund standard deviation and benchmark deviation table. Using the monthly frequency for the fund set up more than 3 years. Using the daily frequency for the fund set up less than 3 years.',
    'funddetailthsummodal8': 'Investing in money market fund is not a money deposit. There is a risk of investing. The investor may not receive the full amount of their investment.',

    // Corporate Governance (cg)
    // menu
    'cgmenu1': 'Investment Governance Code Policy',
    'cgmenu2': 'Code of Conduct',
    'cgmenu3': 'Anti-Corruption Policy',
    'cgmenu4': 'Governance principles for mutual fund products',

    // detail
    'cgdetail': 'Download PDF',

    // Investment Management Supervision (ims)
    // menu
    'imsmenu1': 'FUND MANAGER LIST',
    'imsmenu2': 'Connected Persons Transaction Report',
    'imsmenu3': 'Proxy Voting Policy',
    'imsmenu4': 'Proxy Voting Report',
    'imsmenu5': 'Investment Holdings over One-Third Report',
    'imsmenu6': 'List of personnel assigned to advise investments through media or seminars',

    // detail
    'imsdetail': 'Download PDF',

    // Job Detail
    // header
    'jobdetailheader': 'Details',

    // title
    'jobdetailtitle1': 'Job Descriptions',
    'jobdetailtitle2': 'Qualifications',
    'jobdetailtitle3': 'Contact us',

    // address
    'jobdetailaddress1': 'One Asset Management Limited',
    'jobdetailaddress2': 'Siam Piwat Tower, 9th and 24th  Floor, 989',
    'jobdetailaddress3': 'Rama 1 Road Pathumwan Bangkok 10330',
    'jobdetailaddress4': 'Phone Number: 02-659-8738, 8743, 8741',

    // Job
    // header
    'jobheader': 'Fill out',

    // title icon
    'jobtitleicon1': 'Personal Information',
    'jobtitleicon2': 'Education Background',
    'jobtitleicon3': 'Family Profile',
    'jobtitleicon4': 'Work Experience',

    // error
    'joberror1': 'Fill out',
    'jobeduwarning1': 'The size does not exceed 500 Mb.',
    'jobeduwarning2': 'If a field is blank, please type',
    'jobeduwarning3': 'Delete file.',

    // button
    'jobbtn1': 'Add data set',
    'jobbtn2': 'Delete',
    'jobbtn3': 'Attach file ',
    'jobbtn4': 'Upload',
    'jobbtn5': 'Next',
    'jobbtn6': 'Back',
    'jobbtn7': 'Confirm',
    'jobnumber': 'Set No.',
    'jobchoose': 'Choose',

    // Job personal title
    'jobpersonaltitle1': 'Mr.',
    'jobpersonaltitle2': 'Mrs.',
    'jobpersonaltitle3': 'Ms.',
    'jobpersonaltitle4': 'Master',
    'jobpersonaltitle5': 'Miss(Girl)',

    // Job Apply
    // header
    'jobapplyheader': 'Fill out',

    // personal infomation
    'jobapplypersoninfo1': 'Name Title (Thai)',
    'jobapplypersoninfo2': 'Name (Thai)',
    'jobapplypersoninfo3': 'Surname (Thai)',
    'jobapplypersoninfo4': 'Expected Salary',

    // Job Education
    // Laveleducation
    'jobedulevel': 'Degree',
    'jobedulevel1': 'Master\'s Degree',
    'jobedulevel2': 'Bachelor degree',
    'jobedulevel3': 'Other',
    'jobedulevel4': 'High School/Vocational',

    // year academic
    'jobeduacademicyear': 'Year',

    // uni
    'jobeduuni': 'Institution name',
    'jobedusection': 'Major',

    // date
    'jobedufrom': 'From',
    'jobeduto': 'To',

    // error
    'jobeduerror1': 'Choose',

    // Language
    'jobedutest': 'Please attach language test score.',
    'jobedutestresult1': 'Speaking',
    'jobedutestresult2': 'Understanding',
    'jobedutestresult3': 'Reading',
    'jobedutestresult4': 'Writing',

    // License
    'jobedulicense': 'License Name',
    'jobedulicenseno': 'License Number',
    'jobedulicensedate': 'Expiry Date',

    // Skill
    'jobeducomputerprogram': 'Computer program skills',
    'jobedutalent': 'Special Ability',
    'jobeduskill1': 'Excellent',
    'jobeduskill2': 'Good',
    'jobeduskill3': 'Fair',

    // Month
    'month1': 'Jan',
    'month2': 'Feb',
    'month3': 'Mar',
    'month4': 'Apr',
    'month5': 'May',
    'month6': 'Jun',
    'month7': 'Jul',
    'month8': 'Aug',
    'month9': 'Sep',
    'month10': 'Oct',
    'month11': 'Nov',
    'month12': 'Dec',

    // Job Family
    // Status
    'jobfamstatus1': 'Marriage Status',

    // detail
    'jobfamdetail1': 'Family details',
    'jobfamdetail2': 'Father',
    'jobfamdetail3': 'Mother',
    'jobfamdetail4': 'Brother/Sister',
    'jobfamdetail5': 'Husband/Wife',
    'jobfamdetail6': 'Single',
    'jobfamdetail7': 'Married',
    'jobfamdetail8': 'Widowed',
    'jobfamdetail9': 'Divorced',
    'jobfamdetail10': 'In case of emergency, please notify',

    'jobfamtitle1': 'Name Title',
    'jobfamtitle2': 'Name (Thai)',
    'jobfamtitle3': 'Surname (Thai)',
    'jobfamtitle4': 'Age',
    'jobfamtitle5': 'Phone Number',
    'jobfamtitle6': 'Career',
    'jobfamtitle7': 'Address',
    'jobfamtitle8': 'Relations',
    'jobfamtitle9': 'Phone Number',
    'jobfamtitle10': 'Name',
    'jobfamtitle11': 'Surname',


    // Job Experience
    'jobexptest': 'Please attach resume or CV.',
    'jobexpdetail1': 'Responsibility',
    'jobexpdetail2': 'Characters',

    // Job Comfirm
    'jobcomfirmdetail1': 'Other',
    'jobcomfirmdetail2': 'Person',
    'jobcomfirmdetail3': 'Have you ever been seriouly ill or lame or contracted with contagious disease?',
    'jobcomfirmdetail4': 'If yes, please explain in full',
    'jobcomfirmdetail5': 'Have you ever been arrested, investigated, sued or punished?',
    'jobcomfirmdetail6': 'Have you ever been terminated or dismissed by mistakes?',
    'jobcomfirmdetail7': 'Have you ever been employed by One Asset Management Limited?',
    'jobcomfirmdetail8': 'List person of 2 references who knows you well.',
    'jobcomfirmdetail9': 'I certify that all statements given in this application form are true, correct and complete in all respects. And I hereby confirm that the personal information of any reference person or any person I have identified in this application, I have obtained the consent of the said person before providing that personal information to the company. After engagement, if it appears that the statement on the job application and/or documents that I have presented or given to the company is not true, I agree that the company has the right to terminate my employment without any compensation or severance pays whatsoever.',
    'jobcomfirmdetail10': 'Please certify the accuracy of the information in your job application before click "confirm". ',
    'jobcomfirmdetail11': 'หนังสือให้ความยินยอมในการเก็บ รวบรวม ใช้ และ/หรือเปิดเผยข้อมูลส่วนบุคคล',
    'jobcomfirmdetail12': 'ข้าพเจ้าได้ให้ความยินยอมแก่บริษัทหลักทรัพย์จัดการกองทุน วรรณ จำกัด (“บริษัท”) ในการเก็บรวบรวม ใช้ และ/  หรือ เปิดเผยข้อมูลส่วนบุคคลของข้าพเจ้า ซึ่งรวมถึงข้อมูลอ่อนไหวของข้าพเจ้า ตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 (และตามที่ได้มีการแก้ไขเพิ่มเติม รวมถึงประกาศที่ออกตามพระราชบัญญัติดังกล่าว) และ นโยบายคุ้มครองข้อมูลส่วนบุคคลของบริษัท และข้าพเจ้ายืนยันว่าข้อมูลที่ข้าพเจ้าได้ให้แก่บริษัทมีความถูกต้อง เป็นปัจจุบัน สมบูรณ์ และไม่ก่อให้เกิดความเข้าใจผิด โดยมีรายละเอียดดังต่อไปนี้ ทั้งนี้ คำนิยามที่กำหนดไว้ในนโยบายคุ้มครองข้อมูลส่วนบุคคลของบริษัท จะมีความหมายเช่นเดียวกันเมื่อใช้ในเอกสารฉบับนี้ เว้นแต่จะได้นิยามไว้เป็นอย่างอื่นในเอกสารฉบับนี้',
    'jobcomfirmdetail13': 'ข้าพเจ้ายินยอมให้บริษัทเก็บ รวบรวม ใช้ และ/หรือ เปิดเผยข้อมูลอ่อนไหว ได้แก่ ข้อมูลศาสนา สุขภาพ ความพิการ ประวัติอาชญากรรม ประวัติการถูกลงโทษจากหน่วยงานกำกับดูแล และข้อมูลการกระทำความผิดทั้งทางแพ่งและ อาญา รวมถึงข้อมูลที่จำเป็นอื่นๆ ตามข้อบังคับของหน่วยงานที่กำกับดูแล เช่น สำนักงานคณะกรรมการกำกับหลักทรัพย์และตลาดหลักทรัพย์ สำนักงานป้องกันและปราบปรามการฟอกเงิน ซึ่งเป็นส่วนหนึ่งของขั้นตอนการพิจารณาสรรหาคัดเลือกพนักงานและการว่าจ้างเพื่อปฏิบัติงานในตำแหน่งใดๆ',
    'jobcomfirmdetail14': 'ข้าพเจ้ารับทราบนโยบายข้อมูลส่วนบุคคลของบริษัทรวมถึงสิทธิในการเพิกถอนความยินยอมตามนโยบายคุ้มครองข้อมูลส่วนบุคคลของบริษัทหรือตามช่องทางสื่อสารอื่นใดของบริษัทแล้ว จึงได้ลงลายมือชื่อไว้เป็นหลักฐาน',
    'jobcomfirmdetail15': 'ท่านสามารถตรวจสอบนโยบายความเป็นส่วนตัว (Privacy Policy) ที่ ',
    'jobcomfirmdetail15_2': 'https://www.one-asset.com/privacy-notice',
    'jobcomfirmdetail15_3': ' เพื่อทราบรายละเอียดเกี่ยวกับการจัดเก็บ ใช้ และเปิดเผยข้อมูลส่วนตัวของท่าน รวมถึงสิทธิต่าง ๆ ที่ท่านมีอยู่ตามพระราชบัญญัติคุ้มครองส่วนบุคคล พ.ศ. 2562 ในกรณีที่ท่านประสงค์ที่จะถอนความยินยอมหรือมีข้อสงสัยดังกล่าวข้างต้น สามารถติดต่อบริษัทหลักทรัพย์จัดการกองทุน วรรณ จำกัด โทร 02-659-8888',
    'jobcomfirmdetail16': 'หมายเหตุ',

    // Job
    'jobapplytiltle1': 'Personal Information',
    'jobapplytiltle2': 'Educational Background',

    'jobapplydetail1': 'Telephone No.',
    'jobapplydetail2': 'Mobile No.',
    'jobapplydetail3': 'E-mail',
    'jobapplydetail4': 'Date of Birth',
    'jobapplydetail5': 'Age',
    'jobapplydetail6': 'I.D.Card No.',
    'jobapplydetail7': 'Nationality',
    'jobapplydetail8': 'Religion',
    'jobapplydetail9': 'Place of Birth',
    'jobapplydetail10': 'Present Address',
    'jobapplydetail11': '(Month/Year)',
    'jobapplydetail12': 'GPA',
    'jobapplydetail13': 'Language',
    'jobapplydetail14': 'Language',
    'jobapplydetail15': 'License',
    'jobapplydetail16': 'Family Information',
    'jobapplydetail17': 'Number of your own children',
    'jobapplydetail18': 'Experience',
    'jobapplydetail19': 'Period (Month/Year)',
    'jobapplydetail20': 'From',
    'jobapplydetail21': 'To',
    'jobapplydetail22': 'Company',
    'jobapplydetail23': 'Position',
    'jobapplydetail24': 'Reference Person',
    'jobapplydetail25': 'Relationship',
    'jobapplydetail26': 'Age of child no ',
    'jobapplydetail27': 'Military Status',
    'jobapplydetail28': 'Exempted',
    'jobapplydetail29': 'Non Exempted',
    'jobapplydetail30': 'Territorial Degree Student',
    'jobapplydetail31': 'Date Entered Service',
    'jobapplydetail32': 'Address',
    'jobapplydetail33': 'Training/Seminar',
    'jobapplydetail34': 'Subject',
    'jobapplydetail35': 'Institute',
    'jobapplydetail36': 'Period',
    'jobapplydetail37': 'Married Year (B.E.)',
    'jobapplydetail38': 'Date Avaliable To Start Work',
    'jobapplydetail39': 'Hobbies, Sport, Interest',
    'jobapplydetail40': 'Reason For Leaving',
    'jobapplydetail41': 'Do you have any car/motorcycle?',
    'jobapplydetail42': 'Car',
    'jobapplydetail43': 'Motorcycle',
    'jobapplydetail44': 'Yes',
    'jobapplydetail45': 'No',
    'jobapplydetail46': 'Licence Type',
    'jobapplydetail47': 'Temporarily',
    'jobapplydetail48': 'Permanent',
    'jobapplydetail49': 'How do you know about this employment?',
    'jobapplydetail50': 'www.one-asset.com',
    'jobapplydetail51': 'Recuitment Website',
    'jobapplydetail52': 'OneAM Employee',
    'jobapplydetail53': 'Please specify',
    'jobapplydetail54': 'Please provide any further information\'s about yourself, which will allow our company to know you better',
    'jobapplydetail55': 'No.of Children',
    'jobapplydetail56': 'Yes',
    'jobapplydetail57': 'No',
    'jobapplydetail58': 'Yes',
    'jobapplydetail59': 'No',
    'jobapplydetail60': 'Start salary',
    'jobapplydetail61': 'End salary',

    'jobapplydetailerror1': 'Please enter a valid email address',
    'jobapplydetailerror2': 'Please specific',
    'jobapplydetailerror3': 'Oops. Something went wrong, Please try again later.',

    // Fund Compare
    'fundcompare1': 'Compare Funds',
    'fundcompare2': 'Fund No.1',
    'fundcompare3': 'Fund No.2',
    'fundcompare4': 'SELECT FUND',
    'fundcompare5': 'Please SELECT FUND',
    'fundcompare6': 'Please see the detail here.',
    'fundcompare7': '(If a transaction is made on its Fund Holiday, that transaction will be processed on the next business day of its fund)',
    'fundcompare8': '',
    'fundcompare9': 'within 3.00 pm.',

    // Search page
    'searchpage1': 'Search results',
    'searchpage2': 'Fund',
    'searchpage3': 'NAV',
    'searchpage4': 'News',
    'searchpage5': 'Announcement',
    'searchpage6': 'Earth Update',
    'searchpage7': 'Recommended Fund',
    'searchpage8': 'Promotions',
    'searchpage9': 'Privileges',


    // btn
    'btn1': 'Refuse',
    'btn2': 'Accept',
    'btn3': 'Previous',
    'btn4': 'Next',
    'btn5': 'Run',
    'btn6': 'Delete',
    'btn7': 'Apply',

    // Disclaimer Main Page
    'disclaimer1': 'Disclaimer',
    'disclaimer2': 'Past performance of the mutual fund is not insisting of future performance.',
    'disclaimer3': 'Evaluation of this Mutual Fund is prepared and conducted pursuant to the evaluation standard prescribed by the Association of the Investment Management Company (AIMC).',
    'disclaimer4': 'The calculation of this rate of return is calculated without deducting the trading fee.',
    'disclaimer5': 'The rate of return is shown annualized returns if there are data for more than 1 year.',
    'disclaimer6': 'The adjustment frequency of Composite Benchmark\'s weight is calculated daily.',
    'disclaimer7': 'The standard deviation of the fund and the standard deviation of its benchmark use monthly frequency if the fund set up for more than 3 years. However, the fund set up for less than 3 years, both of the standard deviations use daily frequency instead.',
    'disclaimer8': 'Investment in the mutual fund is not a deposit of money and carries investment risk. The investors may receive the redemption amount higher or lower than the initial investment amount.',

    // Asset Allocation
    // NEW INVESTOR
    'allocation1': 'Summary of Your Assessment',
    'allocation2': 'Your score',
    'allocation3': 'Your investor type',
    'allocation4': 'Majority of investable financial instruments',
    'allocation5': 'Recommended Asset Allocation : ',
    'allocation9': '',
    'allocation6': 'This asset allocation has chance to generate higher returns than deposits. It is suitable for investors who are',
    'allocation7': ' old or can accept ',
    'allocation8': 'Take the suitability test again',

    // investorType
    'allocation10': 'Low risk',
    'allocation11': 'Moderate to low risk',
    'allocation12': 'Moderate to high risk',
    'allocation13': 'High risk',
    'allocation14': 'Very high risk',

    // investment
    'allocation15': 'Debt instruments / Little investment in equity instruments / Investment unit with risk level 1',
    'allocation16': 'Debt instruments / Slightly investment in equity instruments / Investment unit with risk level 1-4',
    'allocation17': 'Debt instruments / Slightly investment - moderate investment in equity instruments / Investment unit with risk level 1-5',
    'allocation18': 'Debt instruments / Moderate investment in equity instruments / Investment unit with risk level 1-7',
    'allocation19': 'Debt instruments / High investment in equity instruments / Investment unit with risk level 1-8',

    // recommRisk
    'allocation20': 'Low Risk',
    'allocation21': 'Moderate Risk',
    'allocation22': 'High Risk',

    // riskLevel
    'allocation23': 'low risk of loss.',
    'allocation24': 'moderate risk of loss.',
    'allocation25': 'high risk of loss.',

    // INVESTMENT TARGET
    'allocation26': 'Step 2: Risk assessment',
    'allocation27': 'Your savings goal ',
    'allocation28': ' baht.',
    'allocation29': 'Your savings goal must be greater than 0.',
    'allocation30': 'Your current savings ',
    'allocation31': 'Your investment period to achieve your goal ',
    'allocation32': ' Years.',
    'allocation33': 'Your investment period to achieve your goal must be greater than 0.',

    'allocation34': 'Step 3: Your acceptable risk level',
    'allocation35': 'Acceptable risk level',

    // RETIREMENT
    'allocation36': 'Step 2: Explore your savings',
    'allocation37': 'Your current age ',
    'allocation38': ' years',
    'allocation39': 'Your current age must be greater than 0.',
    'allocation40': 'Your current savings ',
    'allocation41': ' baht.',
    'allocation42': 'Your expected retirement age ',
    'allocation43': 'Your expected retirement age must be greater than 0 and greater than your current age.',
    'allocation44': 'Your life expectancy ',
    'allocation45': 'Your life expectancy must be greater than 0 and greater than your retirement age.',
    'allocation46': 'Your retirement expenses ',
    'allocation47': ' baht / month',
    'allocation48': 'Your retirement expenses must be greater than 0.',

    'allocation49': 'Step 3: Your acceptable risk level',
    'allocation50': 'Acceptable risk level',

    // FUND
    'direct_debit1': 'ช่องทางการสมัครบริการหักบัญชีอัตโนมัติ (Direct Debit) มี 4 ช่องทางดังนี',
    'direct_debit2': 'สมัครผ่านตู้ ATM',
    'direct_debit3': 'สมัครผ่าน Mobile Application',
    'direct_debit4': 'สมัครผ่าน Website ของธนาคาร',
    'direct_debit5': 'สมัครโดยกรอกแบบฟอร์มหนังสือยินยอมให้หักบัญชีเงินฝาก ยื่นต่อเจ้าหน้าที่ฝ่ายลูกค้าสัมพันธ์และสนับสนุนธุรกิจของบริษัท เมื่อทางบริษัท ได้รับอนุมัติจากธนาคารเจ้าของบัญชีเรียบร้อยแล้ว ทางบริษัทจะแจ้งให้ท่านทราบต่อไป โดยขั้นตอนนี้จะใช้เวลาประมาณ 1 เดือน',
    'direct_debit6': 'ในส่วนของการสมัคร การสั่งซื้อหน่วยลงทุนแบบสม่ำเสมอ (Standing Instruction) มี 3 ช่องทาง',
    'direct_debit7': 'สมัครผ่าน Mobile Application : ONEAM',
    'direct_debit8': 'สมัครผ่าน One Live',
    'direct_debit9': 'สมัครโดยกรอกแบบฟอร์มใบคำสั่งซื้อหน่วยลงทุนอัตโนมัติ',
    'direct_debit10': 'หมายเหตุ : ปัจจุบัน ทางบริษัทจะทำการหักบัญชีอัตโนมัติทุกวันที่ 1 และ 16 ของเดือนเท่านั้น',

    // customer service
    'cs_title': 'Customer Service',
    'cs_pid_title': 'Please fill out the information to manage your consent or for exercise of data subject’s rights. (Existing customers only)',
    'cs_pid_title2': 'For Foreign Customers, Please contact our customer service : Tel 02-659-8888 ext 1',
    'cs_pid': 'Please input ID Card No. / Passport No.',
    'cs_login': 'Submit',
    'cs_otp_title': 'SMS-OTP is sent to mobile no. ',
    'cs_otp_title2': ' to verify your identity.',
    'cs_otp': 'Please input OTP',
    'cs_request_otp': 'Resend OTP',
    'cs_consent': 'Consent Management',
    'cs_dsar': 'Data Subject Rights Request',

    'cs_edoc': 'Investor e-Service',

    // tax consent
    'tax_header': 'Applying for Income Tax Exemption on Investment in Super Savings Funds, Retirement Mutual Fund or Any Other Mutual Funds Qualified for Income Tax Exemption (hereinafter collectively "Tax-Exempted Mutual Fund")',
    'tax_select_year': 'Please select the tax year for which you wish to apply for Income Tax Exemption. To deduct income from investing in Super Savings Funds, Retirement Mutual Fund or any Other Mutual Funds for Income Tax Exemption.',
    'tax_dropdown_header': 'Please select a tax year',
    'tax_dropdown_footer': 'onwards',
    'tax_remark': 'Remarks :',
    'tax_remark1': '1. I hereby acknowledge that this request and consent apply throughout the tax year beginning from <b>2022</b> onwards, until I notify to change of my request in otherwise and, as such, acknowledge that the Company will rely on my latest request.',
    'tax_remark2': '2. Please contact the Company to notify or amend your request within the last business day of the tax year so that your request is effective in the tax year you notify onwards.',
    'tax_remark3': '3. I hereby acknowledge that the Company may disclose any information in connection with my investment in Super Savings Funds, Retirement Mutual Fund or Any Other Mutual Funds Qualified for Income Tax Exemption to the sales supporters of One Asset Management Limited that I have the fund account within order to facilitate the services and account management.',
    'tax_given': 'I hereby request One Asset Management Limited <U>to deliver and disclose</U> any information in connection with my investment in the Tax-Exempted Mutual Funds throughout the tax year beginning from <b>2022</b> onwards the Revenue Department for the benefit of my personal income tax exemption in accordance with the regulations, conditions and procedures prescribed by the Revenue Department.',
    'tax_not_given': 'I hereby request One Asset Management Limited <U>not to deliver and disclose</U> any information in connection with my investment in the Tax-Exempted Mutual Funds to the Revenue Department for the benefit of my personal income tax exemption in accordance with the regulations, conditions and procedures prescribed by the Revenue Department.',
    'tax_not_consent_header': 'Applying for Income Tax Exemption.',
    'tax_not_consent': 'You acknowledge that if you request “not to deliver and disclose”, the Company will not deliver and disclose your investment information in Super Savings Funds, Retirement Mutual Fund or Any Other Mutual Funds Qualified for Income Tax Exemption to the Revenue Department in electronic form.',
    'tax_not_consent2': 'You will not be eligible for Income Tax Exemption on Investment in Super Savings Funds, Retirement Mutual Fund or Any Other Mutual Funds Qualified for Income Tax Exemption.',
    'tax_submit_consent': 'ONEAM has received your request to apply for the income tax exemption according to tax law and consent to deliver and disclose the investment information in Super Savings Funds, Retirement Mutual Fund or Any Other Mutual Funds Qualified for Income Tax Exemption to the Revenue Department. If you would like to change, you could register again.',
    'tax_submit_no_consent': 'ONEAM has been informed that you request not to apply for the income tax exemption according to tax law and do not give consent to deliver and disclose investment information in Super Savings Funds, Retirement Mutual Fund or Any Other Mutual Funds Qualified for Income Tax Exemption to the Revenue Department. If you would like to change, you could register again.',
    'tax_submit': 'Submit',
    'tax_confirm': 'Confirm',
    'tax_cancel': 'Cancel',

    'cs_edoc_dropdown1': 'Applying Income Tax Exemption',
    'cs_edoc_dropdown2': 'e-Certificate Download',
    'cs_edoc_dropdown3': 'Data Subject Rights Request',
    'cs_edoc_dropdown4': 'Request to Change Consent',
    'cs_edoc_onlyOne': '',
    'cs_edoc_profile': 'Profile',

    // e-document
    'ed_edoc101': 'Certificate of Purchase',
    'ed_edoc101_1': 'Certificate available up to 5 years',
    'ed_edoc101_1_remark': "(Note: The latest annual report will be available starting January 16th.)",
    'ed_edoc101_download': 'Download',
    'ed_edoc102': 'Certificate of Redemption',
    'ed_edoc102_1': 'Certificate from January 1<sup>st</sup> last year to present',
    'ed_edoc102_download': 'Download',
    'ed_edoc103': 'Certificate of Transfer',
    'ed_edoc103_download': 'Download',
    'ed_edoc104': 'Confirmation Note',
    'ed_edoc104_1': 'Confirmation Note available up to 3 months',
    'ed_edoc104_download': 'Download',
    'ed_edoc105': 'Statement of Outstanding Units',
    'ed_edoc105_1': 'Statement available up to 1 year',
    'ed_edoc105_download': 'Download',

    'ed_holderno': 'Unitholder',
    'ed_fund_code': 'Fund Code',
    'ed_select_all': 'Select All',
    'ed_year': 'Year',
    'ed_month': 'Month',
    'ed_logout': 'Logout',
    'ed_login': 'Please enter your ID card number or passport number to log in.',
    'ed_customer': 'Name',

    'ed_login_error_405': 'Could not find specific information, please contact Customer Service at Tel. 02-659-8888 press 1.',
    'ed_login_error_404': 'Could not find specific information, please contact Customer Service at Tel. 02-659-8888 press 1.',
    'ed_login_error_403': 'Please wait for 3 minutes before next OTP.',
    'ed_login_error_402': 'Your mobile number is not found to receive OTP, please contact Customer Service at Tel. 02-659-8888 press 1.',

    'ed_loging_error_401': 'Please contact Customer Service at Tel. 02-659-8888 press 1.',

    'ed_otp_error_101': 'Insufficient information, please try again.',
    'ed_otp_error_102': 'OTP is incorrect, please try again or request new OTP.',
    'ed_for_foreigner': 'For foreigner / expat who wants to declare your tax exemption, please contact our Customer Service at 02-659-8888 Press 1.',
    'ed_pop_up': 'Close',

    //index level ktb

    'idl_header': 'INDEX LEVEL',
    'idl_sub_header': 'J.P. Morgan Mozaic XRP Index Linked Fund',
    'idl_dis_0': 'The information on this page, including the index levels for the J.P. Morgan Mozaic XRP Index (J.P. Morgan 4% Vol Target Mozaic XRP 1% Decrement Index (JMAB392E)) (“Index”), is presented by One Asset Management Limited (“ONEAM”) in relation to the ONE COMPLEX RETURN FUND NOT FOR RETAIL INVESTORS (ONE-COMPLEXRETURN) (the “Non-JPM Product”). Such information does not comprise, and may differ from, the official index levels of the Index that is published by the index calculation agent of the Index, and J.P. Morgan Securities plc (“JPMS plc”) or any of its affiliates (together and individually, “JPMorgan”) has no responsibility or liability for any loss or damage arising from any reliance on or use of such information in any way. The Index has been sub-licensed to ONEAM (the “Sub-Licensee”) for the Sub-Licensee’s benefit. Neither the Sub-Licensee nor the Non-JPM Product is sponsored, operated, endorsed, recommended, sold or promoted by JPMorgan. JPMorgan makes no representation and gives no warranty, express or implied, to investors in or those otherwise taking exposure to the Non-JPM Product. Such persons should seek appropriate professional advice before making any investment. The Index has been designed and is compiled, calculated, maintained and sponsored by JPMS plc without regard to the Sub-Licensee, the Non-JPM Product or any investor. JPMS plc is under no obligation to continue compiling, calculating, maintaining or sponsoring the Index. JPMorgan may independently issue or sponsor other indices or products that are similar to and may compete with the Index and the Non-JPM Product. They may also transact in assets referenced in the Index (or in financial instruments such as derivatives that reference those assets). These activities could have a positive or negative effect on the value of the Index and the Non-JPM Product.',
    'idl_dis': 'Disclaimer : The index level information of the J.P. Morgan Mozaic XRP Index (J.P. Morgan 4% Vol Target Mozaic XRP 1% Decrement Index (JMAB392E)) (“Index”), as shown here, is produced by the Index Provider. One Asset Management Limited\'s objective is to disseminate such index information so that unitholders who invest in ONE COMPLEX RETURN FUND NOT FOR RETAIL INVESTORS (ONE-COMPLEXRETURN) can track the J.P. Morgan Mozaic XRP Index (J.P. Morgan 4% Vol Target Mozaic XRP 1% Decrement Index (JMAB392E)) (“Index”) that is used as a reference index according to the fund\'s investment policy only. It is forbidden to use this information as a reference for any other purpose or to conduct any transaction other than the purpose stated above. In this regard, One Asset Management Limited is only a publisher of information for convenience only. Therefore, One Asset Management Limited has no power to control, certify, or confirm the accuracy of the indexes and/or any information related to the indexes and shall not be liable for direct, indirect, or consequential damages arising from the use of such indexes incurred to any person in any circumstance.',
    'btn_idl':'Index Level',

    // asset profile
    'ap_could_not_fine':'Could not find information',
    'ap_HNW':'Hight net Worth (HNW)',
    'ap_UHNW':'Ultra Hight net Worth (UHNW)',
    'ap_Angel':'Angel Investor',
    'ap_btn_Add':"Add",
    'ap_btn_Edit':"Edit",
    'ap_btn_Preview':'Show Infomation',
    'ap_is_Pass':"Pass",
    'ap_is_NotPass':"Not Pass",
    'ap_Assessmnet_date':"Start Date",
    'ap_Due_date':"Expiry Date",
    'ap_Status':"Status",
    'ap_Head_HNW_UHNW':'Hight Net Worth or Ultra Hight Net Worth',
    'ap_Head_Angel':'Angel Investor',
    'ap_btn_save':'Save',
    'ap_btn_back':'Back',
    'ap_popup_confirm':'Confirm',
    'ap_head':'Asset qualification assessment form for investors',
}
